// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }

  var urlBaseHost = getHost(urlBase) || location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Tenant
 * @header lbServices.Tenant
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Tenant` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Tenant",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tenants/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Tenant.members.findById() instead.
            "prototype$__findById__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/members/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.members.destroyById() instead.
            "prototype$__destroyById__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/members/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.members.updateById() instead.
            "prototype$__updateById__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/members/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#prototype$__findById__items
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Find a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for items
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "prototype$__findById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/items/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#prototype$__destroyById__items
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Delete a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/items/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#prototype$__updateById__items
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Update a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "prototype$__updateById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/items/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.departments.findById() instead.
            "prototype$__findById__departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/departments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.departments.destroyById() instead.
            "prototype$__destroyById__departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/departments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.departments.updateById() instead.
            "prototype$__updateById__departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/departments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.forms.findById() instead.
            "prototype$__findById__forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/forms/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.forms.destroyById() instead.
            "prototype$__destroyById__forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/forms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.forms.updateById() instead.
            "prototype$__updateById__forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/forms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.clients.findById() instead.
            "prototype$__findById__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/clients/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.clients.destroyById() instead.
            "prototype$__destroyById__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/clients/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.clients.updateById() instead.
            "prototype$__updateById__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/clients/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.tasktemplate.findById() instead.
            "prototype$__findById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/tasktemplate/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.tasktemplate.destroyById() instead.
            "prototype$__destroyById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/tasktemplate/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.tasktemplate.updateById() instead.
            "prototype$__updateById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/tasktemplate/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.integrations.findById() instead.
            "prototype$__findById__integrations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/integrations/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.integrations.destroyById() instead.
            "prototype$__destroyById__integrations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/integrations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.integrations.updateById() instead.
            "prototype$__updateById__integrations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/integrations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.webhook() instead.
            "prototype$__get__webhook": {
              url: urlBase + "/tenants/:id/webhook",
              method: "GET",
            },

            // INTERNAL. Use Tenant.webhook.create() instead.
            "prototype$__create__webhook": {
              url: urlBase + "/tenants/:id/webhook",
              method: "POST",
            },

            // INTERNAL. Use Tenant.webhook.update() instead.
            "prototype$__update__webhook": {
              url: urlBase + "/tenants/:id/webhook",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.webhook.destroy() instead.
            "prototype$__destroy__webhook": {
              url: urlBase + "/tenants/:id/webhook",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.members() instead.
            "prototype$__get__members": {
              isArray: true,
              url: urlBase + "/tenants/:id/members",
              method: "GET",
            },

            // INTERNAL. Use Tenant.members.create() instead.
            "prototype$__create__members": {
              url: urlBase + "/tenants/:id/members",
              method: "POST",
            },

            // INTERNAL. Use Tenant.members.destroyAll() instead.
            "prototype$__delete__members": {
              url: urlBase + "/tenants/:id/members",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.members.count() instead.
            "prototype$__count__members": {
              url: urlBase + "/tenants/:id/members/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#prototype$__get__items
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Queries items of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "prototype$__get__items": {
              isArray: true,
              url: urlBase + "/tenants/:id/items",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#prototype$__create__items
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Creates a new instance in items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "prototype$__create__items": {
              url: urlBase + "/tenants/:id/items",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#prototype$__delete__items
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Deletes all items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__items": {
              url: urlBase + "/tenants/:id/items",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#prototype$__count__items
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Counts items of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__items": {
              url: urlBase + "/tenants/:id/items/count",
              method: "GET",
            },

            // INTERNAL. Use Tenant.departments() instead.
            "prototype$__get__departments": {
              isArray: true,
              url: urlBase + "/tenants/:id/departments",
              method: "GET",
            },

            // INTERNAL. Use Tenant.departments.create() instead.
            "prototype$__create__departments": {
              url: urlBase + "/tenants/:id/departments",
              method: "POST",
            },

            // INTERNAL. Use Tenant.departments.destroyAll() instead.
            "prototype$__delete__departments": {
              url: urlBase + "/tenants/:id/departments",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.departments.count() instead.
            "prototype$__count__departments": {
              url: urlBase + "/tenants/:id/departments/count",
              method: "GET",
            },

            // INTERNAL. Use Tenant.forms() instead.
            "prototype$__get__forms": {
              isArray: true,
              url: urlBase + "/tenants/:id/forms",
              method: "GET",
            },

            // INTERNAL. Use Tenant.forms.create() instead.
            "prototype$__create__forms": {
              url: urlBase + "/tenants/:id/forms",
              method: "POST",
            },

            // INTERNAL. Use Tenant.forms.destroyAll() instead.
            "prototype$__delete__forms": {
              url: urlBase + "/tenants/:id/forms",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.forms.count() instead.
            "prototype$__count__forms": {
              url: urlBase + "/tenants/:id/forms/count",
              method: "GET",
            },

            // INTERNAL. Use Tenant.clients() instead.
            "prototype$__get__clients": {
              isArray: true,
              url: urlBase + "/tenants/:id/clients",
              method: "GET",
            },

            // INTERNAL. Use Tenant.clients.create() instead.
            "prototype$__create__clients": {
              url: urlBase + "/tenants/:id/clients",
              method: "POST",
            },

            // INTERNAL. Use Tenant.clients.destroyAll() instead.
            "prototype$__delete__clients": {
              url: urlBase + "/tenants/:id/clients",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.clients.count() instead.
            "prototype$__count__clients": {
              url: urlBase + "/tenants/:id/clients/count",
              method: "GET",
            },

            // INTERNAL. Use Tenant.tasktemplate() instead.
            "prototype$__get__tasktemplate": {
              isArray: true,
              url: urlBase + "/tenants/:id/tasktemplate",
              method: "GET",
            },

            // INTERNAL. Use Tenant.tasktemplate.create() instead.
            "prototype$__create__tasktemplate": {
              url: urlBase + "/tenants/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Tenant.tasktemplate.destroyAll() instead.
            "prototype$__delete__tasktemplate": {
              url: urlBase + "/tenants/:id/tasktemplate",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.tasktemplate.count() instead.
            "prototype$__count__tasktemplate": {
              url: urlBase + "/tenants/:id/tasktemplate/count",
              method: "GET",
            },

            // INTERNAL. Use Tenant.integrations() instead.
            "prototype$__get__integrations": {
              isArray: true,
              url: urlBase + "/tenants/:id/integrations",
              method: "GET",
            },

            // INTERNAL. Use Tenant.integrations.create() instead.
            "prototype$__create__integrations": {
              url: urlBase + "/tenants/:id/integrations",
              method: "POST",
            },

            // INTERNAL. Use Tenant.integrations.destroyAll() instead.
            "prototype$__delete__integrations": {
              url: urlBase + "/tenants/:id/integrations",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.integrations.count() instead.
            "prototype$__count__integrations": {
              url: urlBase + "/tenants/:id/integrations/count",
              method: "GET",
            },

            // INTERNAL. Use Tenant.accessLogs() instead.
            "prototype$__get__accessLogs": {
              isArray: true,
              url: urlBase + "/tenants/:id/accessLogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#create
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tenants",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#createMany
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tenants",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#upsert
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tenants",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#exists
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tenants/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#findById
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tenants/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#find
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tenants",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#findOne
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tenants/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#updateAll
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
            "updateAll": {
              url: urlBase + "/tenants/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#deleteById
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tenants/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#count
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tenants/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#prototype$updateAttributes
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tenants/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#createChangeStream
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tenants/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#statistic
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Get tenants statistics
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "statistic": {
              url: urlBase + "/tenants/statistic",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#adminStatistic
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Get particular statistics
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `tenantId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "adminStatistic": {
              url: urlBase + "/tenants/:tenantId/statistic",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#statisticValidations
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Get Validations statistics
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `tenantId` – `{string}` -
             *
             *  - `fechaDesde` – `{date=}` -
             *
             *  - `fechaHasta` – `{date=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "statisticValidations": {
              url: urlBase + "/tenants/:tenantId/statisticValidations/",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#statistic2
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Get particular statistics
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `tenantId` – `{string}` -
             *
             *  - `avgMensual` – `{string=}` -
             *
             *  - `fechaDesde` – `{date=}` -
             *
             *  - `fechaHasta` – `{date=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "statistic2": {
              url: urlBase + "/tenants/:tenantId/statistic2/",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#myTenant
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Get current user tenant
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "myTenant": {
              url: urlBase + "/tenants/myTenant",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#setTenantStatus
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Modify status of Tenant, disabling or enabling it
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `tenantId` – `{string}` -
             *
             *  - `status` – `{boolean}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "setTenantStatus": {
              url: urlBase + "/tenants/setTenantStatus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Tenant#getDataUsersRolesDepartment
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `tenantId` – `{string}` -
             *
             *  - `accessToken` – `{string}` -
             *
             *  - `clientIds` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `members` – `{*=}` -
             */
            "getDataUsersRolesDepartment": {
              url: urlBase + "/tenants/getDataUsersRolesDepartment",
              method: "GET",
            },

            // INTERNAL. Use Department.tenant() instead.
            "::get::Department::tenant": {
              url: urlBase + "/departments/:id/tenant",
              method: "GET",
            },

            // INTERNAL. Use Form.tenant() instead.
            "::get::Form::tenant": {
              url: urlBase + "/forms/:id/tenant",
              method: "GET",
            },

            // INTERNAL. Use Graph.tenant() instead.
            "::get::Graph::tenant": {
              url: urlBase + "/graphs/:id/tenant",
              method: "GET",
            },

            // INTERNAL. Use Integration.tenant() instead.
            "::get::Integration::tenant": {
              url: urlBase + "/integrations/:id/tenant",
              method: "GET",
            },

            // INTERNAL. Use Webhook.tenant() instead.
            "::get::Webhook::tenant": {
              url: urlBase + "/webhooks/:id/tenant",
              method: "GET",
            },

            // INTERNAL. Use Company.tenant() instead.
            "::get::Company::tenant": {
              url: urlBase + "/companies/:id/tenant",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Tenant#updateOrCreate
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Tenant#update
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Tenant#destroyById
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Tenant#removeById
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.Tenant#modelName
        * @propertyOf lbServices.Tenant
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Tenant`.
        */
        R.modelName = "Tenant";

    /**
     * @ngdoc object
     * @name lbServices.Tenant.members
     * @header lbServices.Tenant.members
     * @object
     * @description
     *
     * The object `Tenant.members` groups methods
     * manipulating `Member` instances related to `Tenant`.
     *
     * Call {@link lbServices.Tenant#members Tenant.members()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Tenant#members
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Queries members of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::get::Tenant::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.members#count
             * @methodOf lbServices.Tenant.members
             *
             * @description
             *
             * Counts members of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.members.count = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::count::Tenant::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.members#create
             * @methodOf lbServices.Tenant.members
             *
             * @description
             *
             * Creates a new instance in members of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.create = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::create::Tenant::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.members#createMany
             * @methodOf lbServices.Tenant.members
             *
             * @description
             *
             * Creates a new instance in members of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.createMany = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::createMany::Tenant::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.members#destroyAll
             * @methodOf lbServices.Tenant.members
             *
             * @description
             *
             * Deletes all members of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.members.destroyAll = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::delete::Tenant::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.members#destroyById
             * @methodOf lbServices.Tenant.members
             *
             * @description
             *
             * Delete a related item by id for members.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for members
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.members.destroyById = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::destroyById::Tenant::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.members#findById
             * @methodOf lbServices.Tenant.members
             *
             * @description
             *
             * Find a related item by id for members.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for members
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.findById = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::findById::Tenant::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.members#updateById
             * @methodOf lbServices.Tenant.members
             *
             * @description
             *
             * Update a related item by id for members.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for members
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.updateById = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::updateById::Tenant::members"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Tenant.departments
     * @header lbServices.Tenant.departments
     * @object
     * @description
     *
     * The object `Tenant.departments` groups methods
     * manipulating `Department` instances related to `Tenant`.
     *
     * Call {@link lbServices.Tenant#departments Tenant.departments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Tenant#departments
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Queries departments of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::get::Tenant::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.departments#count
             * @methodOf lbServices.Tenant.departments
             *
             * @description
             *
             * Counts departments of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.departments.count = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::count::Tenant::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.departments#create
             * @methodOf lbServices.Tenant.departments
             *
             * @description
             *
             * Creates a new instance in departments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments.create = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::create::Tenant::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.departments#createMany
             * @methodOf lbServices.Tenant.departments
             *
             * @description
             *
             * Creates a new instance in departments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments.createMany = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::createMany::Tenant::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.departments#destroyAll
             * @methodOf lbServices.Tenant.departments
             *
             * @description
             *
             * Deletes all departments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.departments.destroyAll = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::delete::Tenant::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.departments#destroyById
             * @methodOf lbServices.Tenant.departments
             *
             * @description
             *
             * Delete a related item by id for departments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for departments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.departments.destroyById = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::destroyById::Tenant::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.departments#findById
             * @methodOf lbServices.Tenant.departments
             *
             * @description
             *
             * Find a related item by id for departments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for departments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments.findById = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::findById::Tenant::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.departments#updateById
             * @methodOf lbServices.Tenant.departments
             *
             * @description
             *
             * Update a related item by id for departments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for departments
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments.updateById = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::updateById::Tenant::departments"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Tenant.forms
     * @header lbServices.Tenant.forms
     * @object
     * @description
     *
     * The object `Tenant.forms` groups methods
     * manipulating `Form` instances related to `Tenant`.
     *
     * Call {@link lbServices.Tenant#forms Tenant.forms()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Tenant#forms
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Queries forms of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::get::Tenant::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.forms#count
             * @methodOf lbServices.Tenant.forms
             *
             * @description
             *
             * Counts forms of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.forms.count = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::count::Tenant::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.forms#create
             * @methodOf lbServices.Tenant.forms
             *
             * @description
             *
             * Creates a new instance in forms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms.create = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::create::Tenant::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.forms#createMany
             * @methodOf lbServices.Tenant.forms
             *
             * @description
             *
             * Creates a new instance in forms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms.createMany = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::createMany::Tenant::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.forms#destroyAll
             * @methodOf lbServices.Tenant.forms
             *
             * @description
             *
             * Deletes all forms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.forms.destroyAll = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::delete::Tenant::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.forms#destroyById
             * @methodOf lbServices.Tenant.forms
             *
             * @description
             *
             * Delete a related item by id for forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for forms
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.forms.destroyById = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::destroyById::Tenant::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.forms#findById
             * @methodOf lbServices.Tenant.forms
             *
             * @description
             *
             * Find a related item by id for forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for forms
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms.findById = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::findById::Tenant::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.forms#updateById
             * @methodOf lbServices.Tenant.forms
             *
             * @description
             *
             * Update a related item by id for forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for forms
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms.updateById = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::updateById::Tenant::forms"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Tenant.clients
     * @header lbServices.Tenant.clients
     * @object
     * @description
     *
     * The object `Tenant.clients` groups methods
     * manipulating `Client` instances related to `Tenant`.
     *
     * Call {@link lbServices.Tenant#clients Tenant.clients()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Tenant#clients
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Queries clients of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Tenant::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.clients#count
             * @methodOf lbServices.Tenant.clients
             *
             * @description
             *
             * Counts clients of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.clients.count = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::count::Tenant::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.clients#create
             * @methodOf lbServices.Tenant.clients
             *
             * @description
             *
             * Creates a new instance in clients of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.create = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::create::Tenant::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.clients#createMany
             * @methodOf lbServices.Tenant.clients
             *
             * @description
             *
             * Creates a new instance in clients of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.createMany = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::createMany::Tenant::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.clients#destroyAll
             * @methodOf lbServices.Tenant.clients
             *
             * @description
             *
             * Deletes all clients of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.clients.destroyAll = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::delete::Tenant::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.clients#destroyById
             * @methodOf lbServices.Tenant.clients
             *
             * @description
             *
             * Delete a related item by id for clients.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for clients
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.clients.destroyById = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::destroyById::Tenant::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.clients#findById
             * @methodOf lbServices.Tenant.clients
             *
             * @description
             *
             * Find a related item by id for clients.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for clients
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.findById = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::findById::Tenant::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.clients#updateById
             * @methodOf lbServices.Tenant.clients
             *
             * @description
             *
             * Update a related item by id for clients.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for clients
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.updateById = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::updateById::Tenant::clients"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Tenant.tasktemplate
     * @header lbServices.Tenant.tasktemplate
     * @object
     * @description
     *
     * The object `Tenant.tasktemplate` groups methods
     * manipulating `Tasktemplate` instances related to `Tenant`.
     *
     * Call {@link lbServices.Tenant#tasktemplate Tenant.tasktemplate()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Tenant#tasktemplate
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Queries tasktemplate of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::get::Tenant::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.tasktemplate#count
             * @methodOf lbServices.Tenant.tasktemplate
             *
             * @description
             *
             * Counts tasktemplate of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tasktemplate.count = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::count::Tenant::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.tasktemplate#create
             * @methodOf lbServices.Tenant.tasktemplate
             *
             * @description
             *
             * Creates a new instance in tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.create = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::create::Tenant::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.tasktemplate#createMany
             * @methodOf lbServices.Tenant.tasktemplate
             *
             * @description
             *
             * Creates a new instance in tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.createMany = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::createMany::Tenant::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.tasktemplate#destroyAll
             * @methodOf lbServices.Tenant.tasktemplate
             *
             * @description
             *
             * Deletes all tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tasktemplate.destroyAll = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::delete::Tenant::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.tasktemplate#destroyById
             * @methodOf lbServices.Tenant.tasktemplate
             *
             * @description
             *
             * Delete a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tasktemplate
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tasktemplate.destroyById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::destroyById::Tenant::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.tasktemplate#findById
             * @methodOf lbServices.Tenant.tasktemplate
             *
             * @description
             *
             * Find a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for tasktemplate
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.findById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::findById::Tenant::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.tasktemplate#updateById
             * @methodOf lbServices.Tenant.tasktemplate
             *
             * @description
             *
             * Update a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tasktemplate
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.updateById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::updateById::Tenant::tasktemplate"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Tenant.integrations
     * @header lbServices.Tenant.integrations
     * @object
     * @description
     *
     * The object `Tenant.integrations` groups methods
     * manipulating `Integration` instances related to `Tenant`.
     *
     * Call {@link lbServices.Tenant#integrations Tenant.integrations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Tenant#integrations
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Queries integrations of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
        R.integrations = function() {
          var TargetResource = $injector.get("Integration");
          var action = TargetResource["::get::Tenant::integrations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.integrations#count
             * @methodOf lbServices.Tenant.integrations
             *
             * @description
             *
             * Counts integrations of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.integrations.count = function() {
          var TargetResource = $injector.get("Integration");
          var action = TargetResource["::count::Tenant::integrations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.integrations#create
             * @methodOf lbServices.Tenant.integrations
             *
             * @description
             *
             * Creates a new instance in integrations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
        R.integrations.create = function() {
          var TargetResource = $injector.get("Integration");
          var action = TargetResource["::create::Tenant::integrations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.integrations#createMany
             * @methodOf lbServices.Tenant.integrations
             *
             * @description
             *
             * Creates a new instance in integrations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
        R.integrations.createMany = function() {
          var TargetResource = $injector.get("Integration");
          var action = TargetResource["::createMany::Tenant::integrations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.integrations#destroyAll
             * @methodOf lbServices.Tenant.integrations
             *
             * @description
             *
             * Deletes all integrations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.integrations.destroyAll = function() {
          var TargetResource = $injector.get("Integration");
          var action = TargetResource["::delete::Tenant::integrations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.integrations#destroyById
             * @methodOf lbServices.Tenant.integrations
             *
             * @description
             *
             * Delete a related item by id for integrations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for integrations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.integrations.destroyById = function() {
          var TargetResource = $injector.get("Integration");
          var action = TargetResource["::destroyById::Tenant::integrations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.integrations#findById
             * @methodOf lbServices.Tenant.integrations
             *
             * @description
             *
             * Find a related item by id for integrations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for integrations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
        R.integrations.findById = function() {
          var TargetResource = $injector.get("Integration");
          var action = TargetResource["::findById::Tenant::integrations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.integrations#updateById
             * @methodOf lbServices.Tenant.integrations
             *
             * @description
             *
             * Update a related item by id for integrations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for integrations
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
        R.integrations.updateById = function() {
          var TargetResource = $injector.get("Integration");
          var action = TargetResource["::updateById::Tenant::integrations"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Tenant.webhook
     * @header lbServices.Tenant.webhook
     * @object
     * @description
     *
     * The object `Tenant.webhook` groups methods
     * manipulating `Webhook` instances related to `Tenant`.
     *
     * Call {@link lbServices.Tenant#webhook Tenant.webhook()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Tenant#webhook
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Fetches hasOne relation webhook.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
        R.webhook = function() {
          var TargetResource = $injector.get("Webhook");
          var action = TargetResource["::get::Tenant::webhook"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.webhook#create
             * @methodOf lbServices.Tenant.webhook
             *
             * @description
             *
             * Creates a new instance in webhook of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
        R.webhook.create = function() {
          var TargetResource = $injector.get("Webhook");
          var action = TargetResource["::create::Tenant::webhook"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.webhook#createMany
             * @methodOf lbServices.Tenant.webhook
             *
             * @description
             *
             * Creates a new instance in webhook of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
        R.webhook.createMany = function() {
          var TargetResource = $injector.get("Webhook");
          var action = TargetResource["::createMany::Tenant::webhook"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.webhook#destroy
             * @methodOf lbServices.Tenant.webhook
             *
             * @description
             *
             * Deletes webhook of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.webhook.destroy = function() {
          var TargetResource = $injector.get("Webhook");
          var action = TargetResource["::destroy::Tenant::webhook"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant.webhook#update
             * @methodOf lbServices.Tenant.webhook
             *
             * @description
             *
             * Update webhook of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
        R.webhook.update = function() {
          var TargetResource = $injector.get("Webhook");
          var action = TargetResource["::update::Tenant::webhook"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Tenant#accessLogs
             * @methodOf lbServices.Tenant
             *
             * @description
             *
             * Queries accessLogs of tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessLogs` object.)
             * </em>
             */
        R.accessLogs = function() {
          var TargetResource = $injector.get("AccessLogs");
          var action = TargetResource["::get::Tenant::accessLogs"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Email
 * @header lbServices.Email
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Email` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Email",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Emails/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Email#modelName
        * @propertyOf lbServices.Email
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Email`.
        */
        R.modelName = "Email";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Member
 * @header lbServices.Member
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Member` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Member",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/members/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__findById__teamMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Find a related item by id for teamMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{string}` - Foreign key for teamMembers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$__findById__teamMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/teamMembers/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__destroyById__teamMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Delete a related item by id for teamMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for teamMembers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__teamMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/teamMembers/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__updateById__teamMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Update a related item by id for teamMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for teamMembers
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$__updateById__teamMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/teamMembers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.clients.findById() instead.
            "prototype$__findById__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/:fk",
              method: "GET",
            },

            // INTERNAL. Use Member.clients.destroyById() instead.
            "prototype$__destroyById__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.clients.updateById() instead.
            "prototype$__updateById__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.clients.link() instead.
            "prototype$__link__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.clients.unlink() instead.
            "prototype$__unlink__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.clients.exists() instead.
            "prototype$__exists__clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__findById__clientMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Find a related item by id for clientMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{string}` - Foreign key for clientMembers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$__findById__clientMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clientMembers/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__destroyById__clientMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Delete a related item by id for clientMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for clientMembers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__clientMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clientMembers/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__updateById__clientMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Update a related item by id for clientMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for clientMembers
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$__updateById__clientMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clientMembers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.installations.findById() instead.
            "prototype$__findById__installations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/installations/:fk",
              method: "GET",
            },

            // INTERNAL. Use Member.installations.destroyById() instead.
            "prototype$__destroyById__installations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/installations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.installations.updateById() instead.
            "prototype$__updateById__installations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/installations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.device.destroyById() instead.
            "prototype$__destroyById__device": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/device/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.tags.findById() instead.
            "prototype$__findById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/:fk",
              method: "GET",
            },

            // INTERNAL. Use Member.tags.destroyById() instead.
            "prototype$__destroyById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.tags.updateById() instead.
            "prototype$__updateById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.tags.link() instead.
            "prototype$__link__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.tags.unlink() instead.
            "prototype$__unlink__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.tags.exists() instead.
            "prototype$__exists__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Member.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/members/:id/company",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__get__teamMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Queries teamMembers of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$__get__teamMembers": {
              isArray: true,
              url: urlBase + "/members/:id/teamMembers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__create__teamMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Creates a new instance in teamMembers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$__create__teamMembers": {
              url: urlBase + "/members/:id/teamMembers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__delete__teamMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Deletes all teamMembers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__teamMembers": {
              url: urlBase + "/members/:id/teamMembers",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__count__teamMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Counts teamMembers of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__teamMembers": {
              url: urlBase + "/members/:id/teamMembers/count",
              method: "GET",
            },

            // INTERNAL. Use Member.clients() instead.
            "prototype$__get__clients": {
              isArray: true,
              url: urlBase + "/members/:id/clients",
              method: "GET",
            },

            // INTERNAL. Use Member.clients.create() instead.
            "prototype$__create__clients": {
              url: urlBase + "/members/:id/clients",
              method: "POST",
            },

            // INTERNAL. Use Member.clients.destroyAll() instead.
            "prototype$__delete__clients": {
              url: urlBase + "/members/:id/clients",
              method: "DELETE",
            },

            // INTERNAL. Use Member.clients.count() instead.
            "prototype$__count__clients": {
              url: urlBase + "/members/:id/clients/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__get__clientMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Queries clientMembers of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$__get__clientMembers": {
              isArray: true,
              url: urlBase + "/members/:id/clientMembers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__create__clientMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Creates a new instance in clientMembers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$__create__clientMembers": {
              url: urlBase + "/members/:id/clientMembers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__delete__clientMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Deletes all clientMembers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__clientMembers": {
              url: urlBase + "/members/:id/clientMembers",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$__count__clientMembers
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Counts clientMembers of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__clientMembers": {
              url: urlBase + "/members/:id/clientMembers/count",
              method: "GET",
            },

            // INTERNAL. Use Member.task() instead.
            "prototype$__get__task": {
              isArray: true,
              url: urlBase + "/members/:id/task",
              method: "GET",
            },

            // INTERNAL. Use Member.installations() instead.
            "prototype$__get__installations": {
              isArray: true,
              url: urlBase + "/members/:id/installations",
              method: "GET",
            },

            // INTERNAL. Use Member.installations.create() instead.
            "prototype$__create__installations": {
              url: urlBase + "/members/:id/installations",
              method: "POST",
            },

            // INTERNAL. Use Member.installations.destroyAll() instead.
            "prototype$__delete__installations": {
              url: urlBase + "/members/:id/installations",
              method: "DELETE",
            },

            // INTERNAL. Use Member.installations.count() instead.
            "prototype$__count__installations": {
              url: urlBase + "/members/:id/installations/count",
              method: "GET",
            },

            // INTERNAL. Use Member.device() instead.
            "prototype$__get__device": {
              isArray: true,
              url: urlBase + "/members/:id/device",
              method: "GET",
            },

            // INTERNAL. Use Member.device.destroyAll() instead.
            "prototype$__delete__device": {
              url: urlBase + "/members/:id/device",
              method: "DELETE",
            },

            // INTERNAL. Use Member.tags() instead.
            "prototype$__get__tags": {
              isArray: true,
              url: urlBase + "/members/:id/tags",
              method: "GET",
            },

            // INTERNAL. Use Member.tags.create() instead.
            "prototype$__create__tags": {
              url: urlBase + "/members/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Member.tags.destroyAll() instead.
            "prototype$__delete__tags": {
              url: urlBase + "/members/:id/tags",
              method: "DELETE",
            },

            // INTERNAL. Use Member.tags.count() instead.
            "prototype$__count__tags": {
              url: urlBase + "/members/:id/tags/count",
              method: "GET",
            },

            // INTERNAL. Use Member.accessLogs() instead.
            "prototype$__get__accessLogs": {
              isArray: true,
              url: urlBase + "/members/:id/accessLogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#upsert
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/members",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#findById
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/members/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#find
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/members",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#deleteById
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/members/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#prototype$updateAttributes
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/members/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#login
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `{User}` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/members/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#logout
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/members/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#confirm
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `{User}` - Data of the currently logged in user. (`include=user`)
             *
             */
            "confirm": {
              url: urlBase + "/members/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#roles
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Get the logged in user roles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `roles` – `{*=}` -
             */
            "roles": {
              url: urlBase + "/members/roles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#invite
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Used to invite users to the current tenant. Only admins and maybe department owners should be able to invite users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `Invitations` – `{string=}` -
             */
            "invite": {
              url: urlBase + "/members/invite",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#pushNotification
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Used to invite users to the current tenant. Only admins and maybe department owners should be able to invite users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `pushStatus` – `{string=}` -
             */
            "pushNotification": {
              url: urlBase + "/members/pushNotification",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#killme
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Inactivar y Solicitar eliminación total del usuario
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `Estado` – `{string=}` -
             */
            "killme": {
              url: urlBase + "/members/killme",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#makeadmin
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Adds the admin role to a user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `userId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `New roles` – `{string=}` -
             */
            "makeadmin": {
              url: urlBase + "/members/:userId/makeadmin",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#unmakeadmin
             * @methodOf lbServices.Member
             *
             * @description
             *
             * removes the admin role from a user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `userId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `New roles` – `{string=}` -
             */
            "unmakeadmin": {
              url: urlBase + "/members/:userId/unmakeadmin",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#makesupervisor
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Adds the supervisor role to a user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `userId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `New roles` – `{string=}` -
             */
            "makesupervisor": {
              url: urlBase + "/members/:userId/makesupervisor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#unmakesupervisor
             * @methodOf lbServices.Member
             *
             * @description
             *
             * removes the supervisor role from a user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `userId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `New roles` – `{string=}` -
             */
            "unmakesupervisor": {
              url: urlBase + "/members/:userId/unmakesupervisor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#addClients
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Asign clients to member
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `memberId` – `{string}` -
             *
             *  - `clientsId` – `{Object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{string=}` -
             */
            "addClients": {
              url: urlBase + "/members/:memberId/addClients/",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#toggleActiveStatus
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Update the active status of a member
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` - Member ID
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "toggleActiveStatus": {
              url: urlBase + "/members/:memberId/toggleActiveStatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#delete
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Update the deleted status of a member
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `memberId` – `{string}` - Member ID
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "delete": {
              url: urlBase + "/members/:memberId/delete",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#getHistory
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Get all history entries associated with a member
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `memberId` – `{string}` - Member ID
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "getHistory": {
              isArray: true,
              url: urlBase + "/members/:memberId/history",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#getActiveDeletedCreatedStats
             * @methodOf lbServices.Member
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `startDate` – `{date}` -
             *
             *  - `endDate` – `{date}` -
             *
             *  - `tenantId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `items` – `{object=}` -
             */
            "getActiveDeletedCreatedStats": {
              url: urlBase + "/members/ActiveDeletedCreatedStats",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#ItemsPendingValidations
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Search and filter members pending validations based on query parameters.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `items` – `{*=}` -
             */
            "ItemsPendingValidations": {
              url: urlBase + "/members/ItemsPendingValidations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#generateApiToken
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Generates a new API AccessToken for a specific member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `memberId` – `{string}` - Member ID
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "generateApiToken": {
              url: urlBase + "/members/:memberId/generate-api-token",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#deleteApiToken
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Deletes the existing API AccessToken for a member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `memberId` – `{string}` - Member ID
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "deleteApiToken": {
              url: urlBase + "/members/:memberId/delete-api-token",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#getApiToken
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Retrieves the external API AccessToken for a member inside an array.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `memberId` – `{string}` - Member ID
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "getApiToken": {
              isArray: true,
              url: urlBase + "/members/:memberId/api-token",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#getLoginData
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Retrieves current logged-in user details using the current access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
            "getLoginData": {
              url: urlBase + "/members/get-login",
              method: "GET",
            },

            // INTERNAL. Use Tenant.members.findById() instead.
            "::findById::Tenant::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/members/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.members.destroyById() instead.
            "::destroyById::Tenant::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/members/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.members.updateById() instead.
            "::updateById::Tenant::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/members/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.members() instead.
            "::get::Tenant::members": {
              isArray: true,
              url: urlBase + "/tenants/:id/members",
              method: "GET",
            },

            // INTERNAL. Use Tenant.members.create() instead.
            "::create::Tenant::members": {
              url: urlBase + "/tenants/:id/members",
              method: "POST",
            },

            // INTERNAL. Use Tenant.members.createMany() instead.
            "::createMany::Tenant::members": {
              isArray: true,
              url: urlBase + "/tenants/:id/members",
              method: "POST",
            },

            // INTERNAL. Use Tenant.members.destroyAll() instead.
            "::delete::Tenant::members": {
              url: urlBase + "/tenants/:id/members",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.members.count() instead.
            "::count::Tenant::members": {
              url: urlBase + "/tenants/:id/members/count",
              method: "GET",
            },

            // INTERNAL. Use Client.members.findById() instead.
            "::findById::Client::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.members.destroyById() instead.
            "::destroyById::Client::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.members.updateById() instead.
            "::updateById::Client::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.members.link() instead.
            "::link::Client::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.members.unlink() instead.
            "::unlink::Client::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.members.exists() instead.
            "::exists::Client::members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Client.members() instead.
            "::get::Client::members": {
              isArray: true,
              url: urlBase + "/clients/:id/members",
              method: "GET",
            },

            // INTERNAL. Use Client.members.create() instead.
            "::create::Client::members": {
              url: urlBase + "/clients/:id/members",
              method: "POST",
            },

            // INTERNAL. Use Client.members.createMany() instead.
            "::createMany::Client::members": {
              isArray: true,
              url: urlBase + "/clients/:id/members",
              method: "POST",
            },

            // INTERNAL. Use Client.members.destroyAll() instead.
            "::delete::Client::members": {
              url: urlBase + "/clients/:id/members",
              method: "DELETE",
            },

            // INTERNAL. Use Client.members.count() instead.
            "::count::Client::members": {
              url: urlBase + "/clients/:id/members/count",
              method: "GET",
            },

            // INTERNAL. Use Installation.member() instead.
            "::get::Installation::member": {
              url: urlBase + "/installations/:id/member",
              method: "GET",
            },

            // INTERNAL. Use Company.members() instead.
            "::get::Company::members": {
              isArray: true,
              url: urlBase + "/companies/:id/members",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Member#getCurrent
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/members" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Member#updateOrCreate
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Member#destroyById
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Member#removeById
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

        /**
         * @ngdoc method
         * @name lbServices.Member#getCachedCurrent
         * @methodOf lbServices.Member
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.Member#login} or
         * {@link lbServices.Member#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A Member instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Member#isAuthenticated
         * @methodOf lbServices.Member
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Member#getCurrentId
         * @methodOf lbServices.Member
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.Member#modelName
        * @propertyOf lbServices.Member
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Member`.
        */
        R.modelName = "Member";

    /**
     * @ngdoc object
     * @name lbServices.Member.clients
     * @header lbServices.Member.clients
     * @object
     * @description
     *
     * The object `Member.clients` groups methods
     * manipulating `Client` instances related to `Member`.
     *
     * Call {@link lbServices.Member#clients Member.clients()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Member#clients
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Queries clients of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#count
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Counts clients of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.clients.count = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::count::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#create
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Creates a new instance in clients of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.create = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::create::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#createMany
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Creates a new instance in clients of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.createMany = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::createMany::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#destroyAll
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Deletes all clients of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.clients.destroyAll = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::delete::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#destroyById
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Delete a related item by id for clients.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for clients
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.clients.destroyById = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::destroyById::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#exists
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Check the existence of clients relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for clients
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.exists = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::exists::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#findById
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Find a related item by id for clients.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{string}` - Foreign key for clients
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.findById = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::findById::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#link
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Add a related item by id for clients.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for clients
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.link = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::link::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#unlink
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Remove the clients relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for clients
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.clients.unlink = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::unlink::Member::clients"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.clients#updateById
             * @methodOf lbServices.Member.clients
             *
             * @description
             *
             * Update a related item by id for clients.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for clients
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.clients.updateById = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::updateById::Member::clients"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Member.installations
     * @header lbServices.Member.installations
     * @object
     * @description
     *
     * The object `Member.installations` groups methods
     * manipulating `Installation` instances related to `Member`.
     *
     * Call {@link lbServices.Member#installations Member.installations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Member#installations
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Queries installations of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
        R.installations = function() {
          var TargetResource = $injector.get("Installation");
          var action = TargetResource["::get::Member::installations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.installations#count
             * @methodOf lbServices.Member.installations
             *
             * @description
             *
             * Counts installations of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.installations.count = function() {
          var TargetResource = $injector.get("Installation");
          var action = TargetResource["::count::Member::installations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.installations#create
             * @methodOf lbServices.Member.installations
             *
             * @description
             *
             * Creates a new instance in installations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
        R.installations.create = function() {
          var TargetResource = $injector.get("Installation");
          var action = TargetResource["::create::Member::installations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.installations#createMany
             * @methodOf lbServices.Member.installations
             *
             * @description
             *
             * Creates a new instance in installations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
        R.installations.createMany = function() {
          var TargetResource = $injector.get("Installation");
          var action = TargetResource["::createMany::Member::installations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.installations#destroyAll
             * @methodOf lbServices.Member.installations
             *
             * @description
             *
             * Deletes all installations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.installations.destroyAll = function() {
          var TargetResource = $injector.get("Installation");
          var action = TargetResource["::delete::Member::installations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.installations#destroyById
             * @methodOf lbServices.Member.installations
             *
             * @description
             *
             * Delete a related item by id for installations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for installations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.installations.destroyById = function() {
          var TargetResource = $injector.get("Installation");
          var action = TargetResource["::destroyById::Member::installations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.installations#findById
             * @methodOf lbServices.Member.installations
             *
             * @description
             *
             * Find a related item by id for installations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{string}` - Foreign key for installations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
        R.installations.findById = function() {
          var TargetResource = $injector.get("Installation");
          var action = TargetResource["::findById::Member::installations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.installations#updateById
             * @methodOf lbServices.Member.installations
             *
             * @description
             *
             * Update a related item by id for installations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for installations
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
        R.installations.updateById = function() {
          var TargetResource = $injector.get("Installation");
          var action = TargetResource["::updateById::Member::installations"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Member.device
     * @header lbServices.Member.device
     * @object
     * @description
     *
     * The object `Member.device` groups methods
     * manipulating `Device` instances related to `Member`.
     *
     * Call {@link lbServices.Member#device Member.device()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Member#device
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Queries device of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Device` object.)
             * </em>
             */
        R.device = function() {
          var TargetResource = $injector.get("Device");
          var action = TargetResource["::get::Member::device"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.device#destroyAll
             * @methodOf lbServices.Member.device
             *
             * @description
             *
             * Deletes all device of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.device.destroyAll = function() {
          var TargetResource = $injector.get("Device");
          var action = TargetResource["::delete::Member::device"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.device#destroyById
             * @methodOf lbServices.Member.device
             *
             * @description
             *
             * Delete a related item by id for device.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for device
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.device.destroyById = function() {
          var TargetResource = $injector.get("Device");
          var action = TargetResource["::destroyById::Member::device"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Member.tags
     * @header lbServices.Member.tags
     * @object
     * @description
     *
     * The object `Member.tags` groups methods
     * manipulating `TagDepartment` instances related to `Member`.
     *
     * Call {@link lbServices.Member#tags Member.tags()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Member#tags
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Queries tags of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::get::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#count
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Counts tags of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tags.count = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::count::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#create
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Creates a new instance in tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.create = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::create::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#createMany
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Creates a new instance in tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.createMany = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::createMany::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#destroyAll
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Deletes all tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tags.destroyAll = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::delete::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#destroyById
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Delete a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tags.destroyById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::destroyById::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#exists
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Check the existence of tags relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.exists = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::exists::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#findById
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Find a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{string}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.findById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::findById::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#link
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Add a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.link = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::link::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#unlink
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Remove the tags relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tags.unlink = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::unlink::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member.tags#updateById
             * @methodOf lbServices.Member.tags
             *
             * @description
             *
             * Update a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.updateById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::updateById::Member::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member#company
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Member::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member#task
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Queries task of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R.task = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::get::Member::task"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Member#accessLogs
             * @methodOf lbServices.Member
             *
             * @description
             *
             * Queries accessLogs of member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccessLogs` object.)
             * </em>
             */
        R.accessLogs = function() {
          var TargetResource = $injector.get("AccessLogs");
          var action = TargetResource["::get::Member::accessLogs"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Department
 * @header lbServices.Department
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Department` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Department",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/departments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Department.tenant() instead.
            "prototype$__get__tenant": {
              url: urlBase + "/departments/:id/tenant",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__findById__owners
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find a related item by id for owners.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for owners
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__findById__owners": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/owners/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.teams.findById() instead.
            "prototype$__findById__teams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/teams/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.teams.destroyById() instead.
            "prototype$__destroyById__teams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/teams/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.teams.updateById() instead.
            "prototype$__updateById__teams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/teams/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.forms.findById() instead.
            "prototype$__findById__forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.forms.destroyById() instead.
            "prototype$__destroyById__forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.forms.updateById() instead.
            "prototype$__updateById__forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.graphs.findById() instead.
            "prototype$__findById__graphs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/graphs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.graphs.destroyById() instead.
            "prototype$__destroyById__graphs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/graphs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.graphs.updateById() instead.
            "prototype$__updateById__graphs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/graphs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/departments/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Department.task.findById() instead.
            "prototype$__findById__task": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/task/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.task.destroyById() instead.
            "prototype$__destroyById__task": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/task/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.task.updateById() instead.
            "prototype$__updateById__task": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/task/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.tasktemplate.findById() instead.
            "prototype$__findById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tasktemplate/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.tasktemplate.destroyById() instead.
            "prototype$__destroyById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tasktemplate/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.tasktemplate.updateById() instead.
            "prototype$__updateById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tasktemplate/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.tags.findById() instead.
            "prototype$__findById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tags/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.tags.destroyById() instead.
            "prototype$__destroyById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tags/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.tags.updateById() instead.
            "prototype$__updateById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tags/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__get__owners
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries owners of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__get__owners": {
              isArray: true,
              url: urlBase + "/departments/:id/owners",
              method: "GET",
            },

            // INTERNAL. Use Department.teams() instead.
            "prototype$__get__teams": {
              isArray: true,
              url: urlBase + "/departments/:id/teams",
              method: "GET",
            },

            // INTERNAL. Use Department.teams.create() instead.
            "prototype$__create__teams": {
              url: urlBase + "/departments/:id/teams",
              method: "POST",
            },

            // INTERNAL. Use Department.forms() instead.
            "prototype$__get__forms": {
              isArray: true,
              url: urlBase + "/departments/:id/forms",
              method: "GET",
            },

            // INTERNAL. Use Department.forms.create() instead.
            "prototype$__create__forms": {
              url: urlBase + "/departments/:id/forms",
              method: "POST",
            },

            // INTERNAL. Use Department.graphs() instead.
            "prototype$__get__graphs": {
              isArray: true,
              url: urlBase + "/departments/:id/graphs",
              method: "GET",
            },

            // INTERNAL. Use Department.graphs.create() instead.
            "prototype$__create__graphs": {
              url: urlBase + "/departments/:id/graphs",
              method: "POST",
            },

            // INTERNAL. Use Department.graphs.destroyAll() instead.
            "prototype$__delete__graphs": {
              url: urlBase + "/departments/:id/graphs",
              method: "DELETE",
            },

            // INTERNAL. Use Department.graphs.count() instead.
            "prototype$__count__graphs": {
              url: urlBase + "/departments/:id/graphs/count",
              method: "GET",
            },

            // INTERNAL. Use Department.task() instead.
            "prototype$__get__task": {
              isArray: true,
              url: urlBase + "/departments/:id/task",
              method: "GET",
            },

            // INTERNAL. Use Department.task.create() instead.
            "prototype$__create__task": {
              url: urlBase + "/departments/:id/task",
              method: "POST",
            },

            // INTERNAL. Use Department.task.destroyAll() instead.
            "prototype$__delete__task": {
              url: urlBase + "/departments/:id/task",
              method: "DELETE",
            },

            // INTERNAL. Use Department.task.count() instead.
            "prototype$__count__task": {
              url: urlBase + "/departments/:id/task/count",
              method: "GET",
            },

            // INTERNAL. Use Department.tasktemplate() instead.
            "prototype$__get__tasktemplate": {
              isArray: true,
              url: urlBase + "/departments/:id/tasktemplate",
              method: "GET",
            },

            // INTERNAL. Use Department.tasktemplate.create() instead.
            "prototype$__create__tasktemplate": {
              url: urlBase + "/departments/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Department.tasktemplate.destroyAll() instead.
            "prototype$__delete__tasktemplate": {
              url: urlBase + "/departments/:id/tasktemplate",
              method: "DELETE",
            },

            // INTERNAL. Use Department.tasktemplate.count() instead.
            "prototype$__count__tasktemplate": {
              url: urlBase + "/departments/:id/tasktemplate/count",
              method: "GET",
            },

            // INTERNAL. Use Department.tags() instead.
            "prototype$__get__tags": {
              isArray: true,
              url: urlBase + "/departments/:id/tags",
              method: "GET",
            },

            // INTERNAL. Use Department.tags.create() instead.
            "prototype$__create__tags": {
              url: urlBase + "/departments/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Department.tags.destroyAll() instead.
            "prototype$__delete__tags": {
              url: urlBase + "/departments/:id/tags",
              method: "DELETE",
            },

            // INTERNAL. Use Department.tags.count() instead.
            "prototype$__count__tags": {
              url: urlBase + "/departments/:id/tags/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#create
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/departments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#createMany
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/departments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#upsert
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/departments",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#findById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/departments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#find
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/departments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#deleteById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/departments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$updateAttributes
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/departments/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#addOwner
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Add owners to a specific department. Only Admins have access to this method.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `userId` – `{Object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "addOwner": {
              url: urlBase + "/departments/:departmentId/addowner",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#removeOwner
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Remove owners from a specific department. Only Admins have access to this method.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `userId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{string=}` -
             */
            "removeOwner": {
              url: urlBase + "/departments/:departmentId/removeowner/:userId",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#addTeam
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Adds team to a specific form. Only department owners have access to this method.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `formId` – `{string}` -
             *
             *  - `teamId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{string=}` -
             */
            "addTeam": {
              url: urlBase + "/departments/:departmentId/forms/:formId/addteam/:teamId",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#removeTeam
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Removes team to a specific form. Only department owners have access to this method.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `formId` – `{string}` -
             *
             *  - `teamId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{string=}` -
             */
            "removeTeam": {
              url: urlBase + "/departments/:departmentId/forms/:formId/removeteam/:teamId",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#addTeamMember
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Adds member to team. Only department owners have access to this method.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `teamId` – `{string}` -
             *
             *  - `membersId` – `{Object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "addTeamMember": {
              url: urlBase + "/departments/:departmentId/teams/:teamId/addmember",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#removeTeamMember
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Removes member from team. Only department owners have access to this method.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `teamId` – `{string}` -
             *
             *  - `memberId` – `{Object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{string=}` -
             */
            "removeTeamMember": {
              url: urlBase + "/departments/:departmentId/teams/:teamId/removemember",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#myDepartments
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Get departments for owners.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `context` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "myDepartments": {
              url: urlBase + "/departments/mydepartments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#addTask
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Add task to department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `task` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "addTask": {
              url: urlBase + "/departments/:departmentId/addTask",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#addTasks
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Add task to department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `tasks` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "addTasks": {
              url: urlBase + "/departments/:departmentId/addTasks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#updateTask
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Add task to department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `task` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "updateTask": {
              url: urlBase + "/departments/:departmentId/updateTask",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#deleteTasks
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Removes tasks
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `tasksId` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{string=}` -
             */
            "deleteTasks": {
              url: urlBase + "/departments/:departmentId/deletetasks/",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#pdf
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Make pdf of item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `itemId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{string=}` -
             */
            "pdf": {
              url: urlBase + "/departments/:departmentId/forms/:formId/pdf/:itemId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#html
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Make html of item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `itemId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `body` – `{string=}` -
             */
            "html": {
              url: urlBase + "/departments/:departmentId/forms/:formId/html/:itemId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#json
             * @methodOf lbServices.Department
             *
             * @description
             *
             * json of item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `itemId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `item` – `{string=}` -
             */
            "json": {
              url: urlBase + "/departments/:departmentId/forms/:formId/json/:itemId",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#html_rnd
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Make html of item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `formId` – `{string}` -
             *
             *  - `itemRnd` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `body` – `{string=}` -
             */
            "html_rnd": {
              url: urlBase + "/departments/:departmentId/forms/:formId/html_rnd/:itemRnd",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#TagSync
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Auto Sync Tags of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string}` -
             *
             *  - `spreadsheetId` – `{string}` -
             *
             *  - `range` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "TagSync": {
              url: urlBase + "/departments/:departmentId/TagSync",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__get__forms__tenant
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches belongsTo relation tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__get__forms__tenant": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tenant",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__findById__forms__items
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{string}` - Foreign key for items
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__findById__forms__items": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/items/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__destroyById__forms__items
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__forms__items": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/items/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__updateById__forms__items
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__updateById__forms__items": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/items/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__get__forms__graph
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches belongsTo relation graph.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__get__forms__graph": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/graph",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__findById__forms__tasktemplate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{string}` - Foreign key for tasktemplate
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__findById__forms__tasktemplate": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tasktemplate/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__destroyById__forms__tasktemplate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for tasktemplate
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__forms__tasktemplate": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tasktemplate/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__updateById__forms__tasktemplate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for tasktemplate
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__updateById__forms__tasktemplate": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tasktemplate/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__get__forms__reportConfig
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches hasOne relation reportConfig.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__get__forms__reportConfig": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/reportConfig",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__create__forms__reportConfig
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Creates a new instance in reportConfig of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__create__forms__reportConfig": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/reportConfig",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__update__forms__reportConfig
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update reportConfig of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__update__forms__reportConfig": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/reportConfig",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__destroy__forms__reportConfig
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Deletes reportConfig of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroy__forms__reportConfig": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/reportConfig",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__findById__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Find a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{string}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__findById__forms__tags": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__destroyById__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__forms__tags": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__updateById__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__updateById__forms__tags": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__link__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Add a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__link__forms__tags": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__unlink__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Remove the tags relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__forms__tags": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags/rel/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__exists__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Check the existence of tags relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__exists__forms__tags": {
              params: {
                'nk': '@nk',
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__create__forms__items
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Creates a new instance in items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__create__forms__items": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/items",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__get__forms__tasktemplate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries tasktemplate of form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__get__forms__tasktemplate": {
              isArray: true,
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tasktemplate",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__create__forms__tasktemplate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Creates a new instance in tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__create__forms__tasktemplate": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tasktemplate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__delete__forms__tasktemplate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Deletes all tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__forms__tasktemplate": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tasktemplate",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__count__forms__tasktemplate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Counts tasktemplate of form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__forms__tasktemplate": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tasktemplate/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__get__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries tags of form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__get__forms__tags": {
              isArray: true,
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__create__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Creates a new instance in tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
            "prototype$__create__forms__tags": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__delete__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Deletes all tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__forms__tags": {
              params: {
                'nk': '@nk',
              },
              url: urlBase + "/departments/:id/forms/:nk/tags",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Department#prototype$__count__forms__tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Counts tags of form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `nk` – `{*}` - Foreign key for forms.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__forms__tags": {
              url: urlBase + "/departments/:id/forms/:nk/tags/count",
              method: "GET",
            },

            // INTERNAL. Use Tenant.departments.findById() instead.
            "::findById::Tenant::departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/departments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.departments.destroyById() instead.
            "::destroyById::Tenant::departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/departments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.departments.updateById() instead.
            "::updateById::Tenant::departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/departments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.departments() instead.
            "::get::Tenant::departments": {
              isArray: true,
              url: urlBase + "/tenants/:id/departments",
              method: "GET",
            },

            // INTERNAL. Use Tenant.departments.create() instead.
            "::create::Tenant::departments": {
              url: urlBase + "/tenants/:id/departments",
              method: "POST",
            },

            // INTERNAL. Use Tenant.departments.createMany() instead.
            "::createMany::Tenant::departments": {
              isArray: true,
              url: urlBase + "/tenants/:id/departments",
              method: "POST",
            },

            // INTERNAL. Use Tenant.departments.destroyAll() instead.
            "::delete::Tenant::departments": {
              url: urlBase + "/tenants/:id/departments",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.departments.count() instead.
            "::count::Tenant::departments": {
              url: urlBase + "/tenants/:id/departments/count",
              method: "GET",
            },

            // INTERNAL. Use Graph.department() instead.
            "::get::Graph::department": {
              url: urlBase + "/graphs/:id/department",
              method: "GET",
            },

            // INTERNAL. Use Client.departments.findById() instead.
            "::findById::Client::departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/departments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.departments.destroyById() instead.
            "::destroyById::Client::departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/departments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.departments.updateById() instead.
            "::updateById::Client::departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/departments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.departments() instead.
            "::get::Client::departments": {
              isArray: true,
              url: urlBase + "/clients/:id/departments",
              method: "GET",
            },

            // INTERNAL. Use Client.departments.create() instead.
            "::create::Client::departments": {
              url: urlBase + "/clients/:id/departments",
              method: "POST",
            },

            // INTERNAL. Use Client.departments.createMany() instead.
            "::createMany::Client::departments": {
              isArray: true,
              url: urlBase + "/clients/:id/departments",
              method: "POST",
            },

            // INTERNAL. Use Client.departments.destroyAll() instead.
            "::delete::Client::departments": {
              url: urlBase + "/clients/:id/departments",
              method: "DELETE",
            },

            // INTERNAL. Use Client.departments.count() instead.
            "::count::Client::departments": {
              url: urlBase + "/clients/:id/departments/count",
              method: "GET",
            },

            // INTERNAL. Use Integration.department() instead.
            "::get::Integration::department": {
              url: urlBase + "/integrations/:id/department",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Department#updateOrCreate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Department#destroyById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Department#removeById
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.Department#modelName
        * @propertyOf lbServices.Department
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Department`.
        */
        R.modelName = "Department";


            /**
             * @ngdoc method
             * @name lbServices.Department#tenant
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches belongsTo relation tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R.tenant = function() {
          var TargetResource = $injector.get("Tenant");
          var action = TargetResource["::get::Department::tenant"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Department.teams
     * @header lbServices.Department.teams
     * @object
     * @description
     *
     * The object `Department.teams` groups methods
     * manipulating `Team` instances related to `Department`.
     *
     * Call {@link lbServices.Department#teams Department.teams()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Department#teams
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries teams of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
        R.teams = function() {
          var TargetResource = $injector.get("Team");
          var action = TargetResource["::get::Department::teams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.teams#create
             * @methodOf lbServices.Department.teams
             *
             * @description
             *
             * Creates a new instance in teams of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
        R.teams.create = function() {
          var TargetResource = $injector.get("Team");
          var action = TargetResource["::create::Department::teams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.teams#createMany
             * @methodOf lbServices.Department.teams
             *
             * @description
             *
             * Creates a new instance in teams of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
        R.teams.createMany = function() {
          var TargetResource = $injector.get("Team");
          var action = TargetResource["::createMany::Department::teams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.teams#destroyById
             * @methodOf lbServices.Department.teams
             *
             * @description
             *
             * Delete a related item by id for teams.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for teams
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.teams.destroyById = function() {
          var TargetResource = $injector.get("Team");
          var action = TargetResource["::destroyById::Department::teams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.teams#findById
             * @methodOf lbServices.Department.teams
             *
             * @description
             *
             * Find a related item by id for teams.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for teams
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
        R.teams.findById = function() {
          var TargetResource = $injector.get("Team");
          var action = TargetResource["::findById::Department::teams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.teams#updateById
             * @methodOf lbServices.Department.teams
             *
             * @description
             *
             * Update a related item by id for teams.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for teams
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
        R.teams.updateById = function() {
          var TargetResource = $injector.get("Team");
          var action = TargetResource["::updateById::Department::teams"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Department.forms
     * @header lbServices.Department.forms
     * @object
     * @description
     *
     * The object `Department.forms` groups methods
     * manipulating `Form` instances related to `Department`.
     *
     * Call {@link lbServices.Department#forms Department.forms()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Department#forms
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries forms of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::get::Department::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.forms#create
             * @methodOf lbServices.Department.forms
             *
             * @description
             *
             * Creates a new instance in forms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms.create = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::create::Department::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.forms#createMany
             * @methodOf lbServices.Department.forms
             *
             * @description
             *
             * Creates a new instance in forms of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms.createMany = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::createMany::Department::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.forms#destroyById
             * @methodOf lbServices.Department.forms
             *
             * @description
             *
             * Delete a related item by id for forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for forms
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.forms.destroyById = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::destroyById::Department::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.forms#findById
             * @methodOf lbServices.Department.forms
             *
             * @description
             *
             * Find a related item by id for forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for forms
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms.findById = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::findById::Department::forms"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.forms#updateById
             * @methodOf lbServices.Department.forms
             *
             * @description
             *
             * Update a related item by id for forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for forms
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.forms.updateById = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::updateById::Department::forms"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Department.graphs
     * @header lbServices.Department.graphs
     * @object
     * @description
     *
     * The object `Department.graphs` groups methods
     * manipulating `Graph` instances related to `Department`.
     *
     * Call {@link lbServices.Department#graphs Department.graphs()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Department#graphs
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries graphs of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Graph` object.)
             * </em>
             */
        R.graphs = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::get::Department::graphs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.graphs#count
             * @methodOf lbServices.Department.graphs
             *
             * @description
             *
             * Counts graphs of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.graphs.count = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::count::Department::graphs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.graphs#create
             * @methodOf lbServices.Department.graphs
             *
             * @description
             *
             * Creates a new instance in graphs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Graph` object.)
             * </em>
             */
        R.graphs.create = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::create::Department::graphs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.graphs#createMany
             * @methodOf lbServices.Department.graphs
             *
             * @description
             *
             * Creates a new instance in graphs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Graph` object.)
             * </em>
             */
        R.graphs.createMany = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::createMany::Department::graphs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.graphs#destroyAll
             * @methodOf lbServices.Department.graphs
             *
             * @description
             *
             * Deletes all graphs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.graphs.destroyAll = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::delete::Department::graphs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.graphs#destroyById
             * @methodOf lbServices.Department.graphs
             *
             * @description
             *
             * Delete a related item by id for graphs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for graphs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.graphs.destroyById = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::destroyById::Department::graphs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.graphs#findById
             * @methodOf lbServices.Department.graphs
             *
             * @description
             *
             * Find a related item by id for graphs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for graphs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Graph` object.)
             * </em>
             */
        R.graphs.findById = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::findById::Department::graphs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.graphs#updateById
             * @methodOf lbServices.Department.graphs
             *
             * @description
             *
             * Update a related item by id for graphs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for graphs
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Graph` object.)
             * </em>
             */
        R.graphs.updateById = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::updateById::Department::graphs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department#client
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Department::client"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Department.task
     * @header lbServices.Department.task
     * @object
     * @description
     *
     * The object `Department.task` groups methods
     * manipulating `Task` instances related to `Department`.
     *
     * Call {@link lbServices.Department#task Department.task()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Department#task
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries task of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R.task = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::get::Department::task"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.task#count
             * @methodOf lbServices.Department.task
             *
             * @description
             *
             * Counts task of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.task.count = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::count::Department::task"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.task#create
             * @methodOf lbServices.Department.task
             *
             * @description
             *
             * Creates a new instance in task of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R.task.create = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::create::Department::task"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.task#createMany
             * @methodOf lbServices.Department.task
             *
             * @description
             *
             * Creates a new instance in task of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R.task.createMany = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::createMany::Department::task"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.task#destroyAll
             * @methodOf lbServices.Department.task
             *
             * @description
             *
             * Deletes all task of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.task.destroyAll = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::delete::Department::task"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.task#destroyById
             * @methodOf lbServices.Department.task
             *
             * @description
             *
             * Delete a related item by id for task.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for task
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.task.destroyById = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::destroyById::Department::task"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.task#findById
             * @methodOf lbServices.Department.task
             *
             * @description
             *
             * Find a related item by id for task.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for task
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R.task.findById = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::findById::Department::task"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.task#updateById
             * @methodOf lbServices.Department.task
             *
             * @description
             *
             * Update a related item by id for task.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for task
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
        R.task.updateById = function() {
          var TargetResource = $injector.get("Task");
          var action = TargetResource["::updateById::Department::task"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Department.tasktemplate
     * @header lbServices.Department.tasktemplate
     * @object
     * @description
     *
     * The object `Department.tasktemplate` groups methods
     * manipulating `Tasktemplate` instances related to `Department`.
     *
     * Call {@link lbServices.Department#tasktemplate Department.tasktemplate()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Department#tasktemplate
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries tasktemplate of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::get::Department::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tasktemplate#count
             * @methodOf lbServices.Department.tasktemplate
             *
             * @description
             *
             * Counts tasktemplate of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tasktemplate.count = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::count::Department::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tasktemplate#create
             * @methodOf lbServices.Department.tasktemplate
             *
             * @description
             *
             * Creates a new instance in tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.create = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::create::Department::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tasktemplate#createMany
             * @methodOf lbServices.Department.tasktemplate
             *
             * @description
             *
             * Creates a new instance in tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.createMany = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::createMany::Department::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tasktemplate#destroyAll
             * @methodOf lbServices.Department.tasktemplate
             *
             * @description
             *
             * Deletes all tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tasktemplate.destroyAll = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::delete::Department::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tasktemplate#destroyById
             * @methodOf lbServices.Department.tasktemplate
             *
             * @description
             *
             * Delete a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tasktemplate
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tasktemplate.destroyById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::destroyById::Department::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tasktemplate#findById
             * @methodOf lbServices.Department.tasktemplate
             *
             * @description
             *
             * Find a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for tasktemplate
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.findById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::findById::Department::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tasktemplate#updateById
             * @methodOf lbServices.Department.tasktemplate
             *
             * @description
             *
             * Update a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tasktemplate
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.updateById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::updateById::Department::tasktemplate"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Department.tags
     * @header lbServices.Department.tags
     * @object
     * @description
     *
     * The object `Department.tags` groups methods
     * manipulating `TagDepartment` instances related to `Department`.
     *
     * Call {@link lbServices.Department#tags Department.tags()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Department#tags
             * @methodOf lbServices.Department
             *
             * @description
             *
             * Queries tags of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::get::Department::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tags#count
             * @methodOf lbServices.Department.tags
             *
             * @description
             *
             * Counts tags of department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tags.count = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::count::Department::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tags#create
             * @methodOf lbServices.Department.tags
             *
             * @description
             *
             * Creates a new instance in tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.create = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::create::Department::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tags#createMany
             * @methodOf lbServices.Department.tags
             *
             * @description
             *
             * Creates a new instance in tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.createMany = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::createMany::Department::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tags#destroyAll
             * @methodOf lbServices.Department.tags
             *
             * @description
             *
             * Deletes all tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tags.destroyAll = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::delete::Department::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tags#destroyById
             * @methodOf lbServices.Department.tags
             *
             * @description
             *
             * Delete a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tags.destroyById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::destroyById::Department::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tags#findById
             * @methodOf lbServices.Department.tags
             *
             * @description
             *
             * Find a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.findById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::findById::Department::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Department.tags#updateById
             * @methodOf lbServices.Department.tags
             *
             * @description
             *
             * Update a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.updateById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::updateById::Department::tags"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Team
 * @header lbServices.Team
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Team` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Team",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/teams/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Team#prototype$__findById__teamMembers
             * @methodOf lbServices.Team
             *
             * @description
             *
             * Find a related item by id for teamMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for teamMembers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
            "prototype$__findById__teamMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teams/:id/teamMembers/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Team#prototype$__destroyById__teamMembers
             * @methodOf lbServices.Team
             *
             * @description
             *
             * Delete a related item by id for teamMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for teamMembers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__teamMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teams/:id/teamMembers/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Team#prototype$__updateById__teamMembers
             * @methodOf lbServices.Team
             *
             * @description
             *
             * Update a related item by id for teamMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for teamMembers
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
            "prototype$__updateById__teamMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/teams/:id/teamMembers/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Team#prototype$__get__teamMembers
             * @methodOf lbServices.Team
             *
             * @description
             *
             * Queries teamMembers of team.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
            "prototype$__get__teamMembers": {
              isArray: true,
              url: urlBase + "/teams/:id/teamMembers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Team#prototype$__create__teamMembers
             * @methodOf lbServices.Team
             *
             * @description
             *
             * Creates a new instance in teamMembers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Team` object.)
             * </em>
             */
            "prototype$__create__teamMembers": {
              url: urlBase + "/teams/:id/teamMembers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Team#prototype$__delete__teamMembers
             * @methodOf lbServices.Team
             *
             * @description
             *
             * Deletes all teamMembers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__teamMembers": {
              url: urlBase + "/teams/:id/teamMembers",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Team#prototype$__count__teamMembers
             * @methodOf lbServices.Team
             *
             * @description
             *
             * Counts teamMembers of team.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__teamMembers": {
              url: urlBase + "/teams/:id/teamMembers/count",
              method: "GET",
            },

            // INTERNAL. Use Department.teams.findById() instead.
            "::findById::Department::teams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/teams/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.teams.destroyById() instead.
            "::destroyById::Department::teams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/teams/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.teams.updateById() instead.
            "::updateById::Department::teams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/teams/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.teams() instead.
            "::get::Department::teams": {
              isArray: true,
              url: urlBase + "/departments/:id/teams",
              method: "GET",
            },

            // INTERNAL. Use Department.teams.create() instead.
            "::create::Department::teams": {
              url: urlBase + "/departments/:id/teams",
              method: "POST",
            },

            // INTERNAL. Use Department.teams.createMany() instead.
            "::createMany::Department::teams": {
              isArray: true,
              url: urlBase + "/departments/:id/teams",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Team#modelName
        * @propertyOf lbServices.Team
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Team`.
        */
        R.modelName = "Team";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Form
 * @header lbServices.Form
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Form` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Form",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/forms/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Form.tenant() instead.
            "prototype$__get__tenant": {
              url: urlBase + "/forms/:id/tenant",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#prototype$__findById__items
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Find a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for items
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
            "prototype$__findById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/items/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#prototype$__destroyById__items
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Delete a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/items/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#prototype$__updateById__items
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Update a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
            "prototype$__updateById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/items/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Form.graph() instead.
            "prototype$__get__graph": {
              url: urlBase + "/forms/:id/graph",
              method: "GET",
            },

            // INTERNAL. Use Form.tasktemplate.findById() instead.
            "prototype$__findById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tasktemplate/:fk",
              method: "GET",
            },

            // INTERNAL. Use Form.tasktemplate.destroyById() instead.
            "prototype$__destroyById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tasktemplate/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tasktemplate.updateById() instead.
            "prototype$__updateById__tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tasktemplate/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Form.reportConfig() instead.
            "prototype$__get__reportConfig": {
              url: urlBase + "/forms/:id/reportConfig",
              method: "GET",
            },

            // INTERNAL. Use Form.reportConfig.create() instead.
            "prototype$__create__reportConfig": {
              url: urlBase + "/forms/:id/reportConfig",
              method: "POST",
            },

            // INTERNAL. Use Form.reportConfig.update() instead.
            "prototype$__update__reportConfig": {
              url: urlBase + "/forms/:id/reportConfig",
              method: "PUT",
            },

            // INTERNAL. Use Form.reportConfig.destroy() instead.
            "prototype$__destroy__reportConfig": {
              url: urlBase + "/forms/:id/reportConfig",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tags.findById() instead.
            "prototype$__findById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/:fk",
              method: "GET",
            },

            // INTERNAL. Use Form.tags.destroyById() instead.
            "prototype$__destroyById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tags.updateById() instead.
            "prototype$__updateById__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Form.tags.link() instead.
            "prototype$__link__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Form.tags.unlink() instead.
            "prototype$__unlink__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tags.exists() instead.
            "prototype$__exists__tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#prototype$__create__items
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Creates a new instance in items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
            "prototype$__create__items": {
              url: urlBase + "/forms/:id/items",
              method: "POST",
            },

            // INTERNAL. Use Form.tasktemplate() instead.
            "prototype$__get__tasktemplate": {
              isArray: true,
              url: urlBase + "/forms/:id/tasktemplate",
              method: "GET",
            },

            // INTERNAL. Use Form.tasktemplate.create() instead.
            "prototype$__create__tasktemplate": {
              url: urlBase + "/forms/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Form.tasktemplate.destroyAll() instead.
            "prototype$__delete__tasktemplate": {
              url: urlBase + "/forms/:id/tasktemplate",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tasktemplate.count() instead.
            "prototype$__count__tasktemplate": {
              url: urlBase + "/forms/:id/tasktemplate/count",
              method: "GET",
            },

            // INTERNAL. Use Form.tags() instead.
            "prototype$__get__tags": {
              isArray: true,
              url: urlBase + "/forms/:id/tags",
              method: "GET",
            },

            // INTERNAL. Use Form.tags.create() instead.
            "prototype$__create__tags": {
              url: urlBase + "/forms/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Form.tags.destroyAll() instead.
            "prototype$__delete__tags": {
              url: urlBase + "/forms/:id/tags",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tags.count() instead.
            "prototype$__count__tags": {
              url: urlBase + "/forms/:id/tags/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#findById
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/forms/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#find
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/forms",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#findOne
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/forms/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#count
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/forms/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#mySubscriptions
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get current users subscribed forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "mySubscriptions": {
              url: urlBase + "/forms/mysubscriptions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#itemsPendingCount
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get form's items of the current user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `departmentId` – `{string=}` -
             *
             *  - `formId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "itemsPendingCount": {
              url: urlBase + "/forms/:formId/itemsPendingCount",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#validators
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get form's items of the current user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `formId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "validators": {
              url: urlBase + "/forms/:formId/validators",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#myItems
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get form's items of the current user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `departmentId` – `{string=}` -
             *
             *  - `formId` – `{string}` -
             *
             *  - `only_values` – `{boolean=}` -
             *
             *  - `query` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "myItems": {
              url: urlBase + "/forms/:formId/myitems",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#validateItem
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Admin/Owner/Supervisor can validate a item
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `itemId` – `{string}` -
             *
             *  - `validate` – `{object}` - {
             *           "state": "OK",
             *           "comments":"OKK"
             *           }
             *
             *  - `validationStage` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `status` – `{string=}` -
             */
            "validateItem": {
              url: urlBase + "/forms/validateItem/:itemId",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#myWorkFlows
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get current users subscribed forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "myWorkFlows": {
              url: urlBase + "/forms/myworkflows",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#myPTW
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get current users subscribed forms.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "myPTW": {
              url: urlBase + "/forms/myptw",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#myMeasurements
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get current users subscribed form type Measurement.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "myMeasurements": {
              url: urlBase + "/forms/mymeasurements",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#CancelLastValidation
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Cancel last validation of an Item requiring validation.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `itemId` – `{string}` -
             *
             *  - `data` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `item` – `{object=}` -
             */
            "CancelLastValidation": {
              url: urlBase + "/forms/CancelLastValidation/:itemId",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#UsersSubscribed
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get members subscribed to collection of forms
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `members` – `{object=}` -
             */
            "UsersSubscribed": {
              url: urlBase + "/forms/UsersSubscribed",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#UsersSubscribed
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get members subscribed to collection of forms
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `members` – `{object=}` -
             */
            "UsersSubscribed": {
              url: urlBase + "/forms/UsersSubscribed",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#myPMs
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get current item type pm o.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "myPMs": {
              url: urlBase + "/forms/mypms",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#saveActionResponse
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Save Action Response.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{Object=}` -
             */
            "saveActionResponse": {
              url: urlBase + "/forms/saveActionResponse",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#findActionsReponse
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get actions responses.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `formId` – `{string}` -
             *
             *  - `actionId` – `{string}` -
             *
             *  - `dateFrom` – `{date=}` -
             *
             *  - `dateTo` – `{date=}` -
             *
             *  - `responseFilter` – `{*=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
            "findActionsReponse": {
              isArray: true,
              url: urlBase + "/forms/:formId/actions/:actionId/actionResponses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Form#findIntegrations
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Get Integrations in a Form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `formId` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
            "findIntegrations": {
              isArray: true,
              url: urlBase + "/forms/:formId/integrations",
              method: "GET",
            },

            // INTERNAL. Use Tenant.forms.findById() instead.
            "::findById::Tenant::forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/forms/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.forms.destroyById() instead.
            "::destroyById::Tenant::forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/forms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.forms.updateById() instead.
            "::updateById::Tenant::forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/forms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.forms() instead.
            "::get::Tenant::forms": {
              isArray: true,
              url: urlBase + "/tenants/:id/forms",
              method: "GET",
            },

            // INTERNAL. Use Tenant.forms.create() instead.
            "::create::Tenant::forms": {
              url: urlBase + "/tenants/:id/forms",
              method: "POST",
            },

            // INTERNAL. Use Tenant.forms.createMany() instead.
            "::createMany::Tenant::forms": {
              isArray: true,
              url: urlBase + "/tenants/:id/forms",
              method: "POST",
            },

            // INTERNAL. Use Tenant.forms.destroyAll() instead.
            "::delete::Tenant::forms": {
              url: urlBase + "/tenants/:id/forms",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.forms.count() instead.
            "::count::Tenant::forms": {
              url: urlBase + "/tenants/:id/forms/count",
              method: "GET",
            },

            // INTERNAL. Use Department.forms.findById() instead.
            "::findById::Department::forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.forms.destroyById() instead.
            "::destroyById::Department::forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.forms.updateById() instead.
            "::updateById::Department::forms": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/forms/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.forms() instead.
            "::get::Department::forms": {
              isArray: true,
              url: urlBase + "/departments/:id/forms",
              method: "GET",
            },

            // INTERNAL. Use Department.forms.create() instead.
            "::create::Department::forms": {
              url: urlBase + "/departments/:id/forms",
              method: "POST",
            },

            // INTERNAL. Use Department.forms.createMany() instead.
            "::createMany::Department::forms": {
              isArray: true,
              url: urlBase + "/departments/:id/forms",
              method: "POST",
            },

            // INTERNAL. Use Tasktemplate.form() instead.
            "::get::Tasktemplate::form": {
              url: urlBase + "/tasktemplates/:id/form",
              method: "GET",
            },

            // INTERNAL. Use ReportConfig.form() instead.
            "::get::ReportConfig::form": {
              url: urlBase + "/reportConfigs/:id/form",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Form#modelName
        * @propertyOf lbServices.Form
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Form`.
        */
        R.modelName = "Form";


            /**
             * @ngdoc method
             * @name lbServices.Form#tenant
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Fetches belongsTo relation tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R.tenant = function() {
          var TargetResource = $injector.get("Tenant");
          var action = TargetResource["::get::Form::tenant"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form#graph
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Fetches belongsTo relation graph.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Graph` object.)
             * </em>
             */
        R.graph = function() {
          var TargetResource = $injector.get("Graph");
          var action = TargetResource["::get::Form::graph"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Form.tasktemplate
     * @header lbServices.Form.tasktemplate
     * @object
     * @description
     *
     * The object `Form.tasktemplate` groups methods
     * manipulating `Tasktemplate` instances related to `Form`.
     *
     * Call {@link lbServices.Form#tasktemplate Form.tasktemplate()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Form#tasktemplate
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Queries tasktemplate of form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::get::Form::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tasktemplate#count
             * @methodOf lbServices.Form.tasktemplate
             *
             * @description
             *
             * Counts tasktemplate of form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tasktemplate.count = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::count::Form::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tasktemplate#create
             * @methodOf lbServices.Form.tasktemplate
             *
             * @description
             *
             * Creates a new instance in tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.create = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::create::Form::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tasktemplate#createMany
             * @methodOf lbServices.Form.tasktemplate
             *
             * @description
             *
             * Creates a new instance in tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.createMany = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::createMany::Form::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tasktemplate#destroyAll
             * @methodOf lbServices.Form.tasktemplate
             *
             * @description
             *
             * Deletes all tasktemplate of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tasktemplate.destroyAll = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::delete::Form::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tasktemplate#destroyById
             * @methodOf lbServices.Form.tasktemplate
             *
             * @description
             *
             * Delete a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tasktemplate
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tasktemplate.destroyById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::destroyById::Form::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tasktemplate#findById
             * @methodOf lbServices.Form.tasktemplate
             *
             * @description
             *
             * Find a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for tasktemplate
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.findById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::findById::Form::tasktemplate"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tasktemplate#updateById
             * @methodOf lbServices.Form.tasktemplate
             *
             * @description
             *
             * Update a related item by id for tasktemplate.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tasktemplate
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tasktemplate` object.)
             * </em>
             */
        R.tasktemplate.updateById = function() {
          var TargetResource = $injector.get("Tasktemplate");
          var action = TargetResource["::updateById::Form::tasktemplate"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Form.reportConfig
     * @header lbServices.Form.reportConfig
     * @object
     * @description
     *
     * The object `Form.reportConfig` groups methods
     * manipulating `ReportConfig` instances related to `Form`.
     *
     * Call {@link lbServices.Form#reportConfig Form.reportConfig()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Form#reportConfig
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Fetches hasOne relation reportConfig.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
        R.reportConfig = function() {
          var TargetResource = $injector.get("ReportConfig");
          var action = TargetResource["::get::Form::reportConfig"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.reportConfig#create
             * @methodOf lbServices.Form.reportConfig
             *
             * @description
             *
             * Creates a new instance in reportConfig of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
        R.reportConfig.create = function() {
          var TargetResource = $injector.get("ReportConfig");
          var action = TargetResource["::create::Form::reportConfig"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.reportConfig#createMany
             * @methodOf lbServices.Form.reportConfig
             *
             * @description
             *
             * Creates a new instance in reportConfig of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
        R.reportConfig.createMany = function() {
          var TargetResource = $injector.get("ReportConfig");
          var action = TargetResource["::createMany::Form::reportConfig"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.reportConfig#destroy
             * @methodOf lbServices.Form.reportConfig
             *
             * @description
             *
             * Deletes reportConfig of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.reportConfig.destroy = function() {
          var TargetResource = $injector.get("ReportConfig");
          var action = TargetResource["::destroy::Form::reportConfig"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.reportConfig#update
             * @methodOf lbServices.Form.reportConfig
             *
             * @description
             *
             * Update reportConfig of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
        R.reportConfig.update = function() {
          var TargetResource = $injector.get("ReportConfig");
          var action = TargetResource["::update::Form::reportConfig"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Form.tags
     * @header lbServices.Form.tags
     * @object
     * @description
     *
     * The object `Form.tags` groups methods
     * manipulating `TagDepartment` instances related to `Form`.
     *
     * Call {@link lbServices.Form#tags Form.tags()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Form#tags
             * @methodOf lbServices.Form
             *
             * @description
             *
             * Queries tags of form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::get::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#count
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Counts tags of form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tags.count = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::count::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#create
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Creates a new instance in tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.create = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::create::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#createMany
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Creates a new instance in tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.createMany = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::createMany::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#destroyAll
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Deletes all tags of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tags.destroyAll = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::delete::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#destroyById
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Delete a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tags.destroyById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::destroyById::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#exists
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Check the existence of tags relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.exists = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::exists::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#findById
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Find a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.findById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::findById::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#link
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Add a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.link = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::link::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#unlink
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Remove the tags relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tags.unlink = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::unlink::Form::tags"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Form.tags#updateById
             * @methodOf lbServices.Form.tags
             *
             * @description
             *
             * Update a related item by id for tags.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tags
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagDepartment` object.)
             * </em>
             */
        R.tags.updateById = function() {
          var TargetResource = $injector.get("TagDepartment");
          var action = TargetResource["::updateById::Form::tags"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Graph
 * @header lbServices.Graph
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Graph` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Graph",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/graphs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Graph.department() instead.
            "prototype$__get__department": {
              url: urlBase + "/graphs/:id/department",
              method: "GET",
            },

            // INTERNAL. Use Graph.tenant() instead.
            "prototype$__get__tenant": {
              url: urlBase + "/graphs/:id/tenant",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Graph#findById
             * @methodOf lbServices.Graph
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Graph` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/graphs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Graph#find
             * @methodOf lbServices.Graph
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Graph` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/graphs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Graph#count
             * @methodOf lbServices.Graph
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/graphs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Graph#getDistinctItemFromFormField
             * @methodOf lbServices.Graph
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `field` – `{string=}` -
             *
             *  - `query` – `{string=}` -
             *
             *  - `groupRepeated` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `values` – `{Object=}` -
             */
            "getDistinctItemFromFormField": {
              url: urlBase + "/graphs/getDistinctItemFromFormField",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Graph#getItems
             * @methodOf lbServices.Graph
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `fields` – `{string=}` -
             *
             *  - `query` – `{string=}` -
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `values` – `{Object=}` -
             */
            "getItems": {
              url: urlBase + "/graphs/getItems",
              method: "POST",
            },

            // INTERNAL. Use Department.graphs.findById() instead.
            "::findById::Department::graphs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/graphs/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.graphs.destroyById() instead.
            "::destroyById::Department::graphs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/graphs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.graphs.updateById() instead.
            "::updateById::Department::graphs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/graphs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.graphs() instead.
            "::get::Department::graphs": {
              isArray: true,
              url: urlBase + "/departments/:id/graphs",
              method: "GET",
            },

            // INTERNAL. Use Department.graphs.create() instead.
            "::create::Department::graphs": {
              url: urlBase + "/departments/:id/graphs",
              method: "POST",
            },

            // INTERNAL. Use Department.graphs.createMany() instead.
            "::createMany::Department::graphs": {
              isArray: true,
              url: urlBase + "/departments/:id/graphs",
              method: "POST",
            },

            // INTERNAL. Use Department.graphs.destroyAll() instead.
            "::delete::Department::graphs": {
              url: urlBase + "/departments/:id/graphs",
              method: "DELETE",
            },

            // INTERNAL. Use Department.graphs.count() instead.
            "::count::Department::graphs": {
              url: urlBase + "/departments/:id/graphs/count",
              method: "GET",
            },

            // INTERNAL. Use Form.graph() instead.
            "::get::Form::graph": {
              url: urlBase + "/forms/:id/graph",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Graph#modelName
        * @propertyOf lbServices.Graph
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Graph`.
        */
        R.modelName = "Graph";


            /**
             * @ngdoc method
             * @name lbServices.Graph#department
             * @methodOf lbServices.Graph
             *
             * @description
             *
             * Fetches belongsTo relation department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.department = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::get::Graph::department"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Graph#tenant
             * @methodOf lbServices.Graph
             *
             * @description
             *
             * Fetches belongsTo relation tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R.tenant = function() {
          var TargetResource = $injector.get("Tenant");
          var action = TargetResource["::get::Graph::tenant"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Container
 * @header lbServices.Container
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Container` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Container",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/containers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Container#removeFile
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             *  - `file` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/containers/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#upload
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/containers/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#download
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             *  - `file` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/containers/:container/download/:file",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Container#modelName
        * @propertyOf lbServices.Container
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Container`.
        */
        R.modelName = "Container";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Client
 * @header lbServices.Client
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Client` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Client",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/clients/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Client.departments.findById() instead.
            "prototype$__findById__departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/departments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.departments.destroyById() instead.
            "prototype$__destroyById__departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/departments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.departments.updateById() instead.
            "prototype$__updateById__departments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/departments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.parent() instead.
            "prototype$__get__parent": {
              url: urlBase + "/clients/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Client.members.findById() instead.
            "prototype$__findById__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/:fk",
              method: "GET",
            },

            // INTERNAL. Use Client.members.destroyById() instead.
            "prototype$__destroyById__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.members.updateById() instead.
            "prototype$__updateById__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.members.link() instead.
            "prototype$__link__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Client.members.unlink() instead.
            "prototype$__unlink__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.members.exists() instead.
            "prototype$__exists__members": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/members/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__findById__clientMembers
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find a related item by id for clientMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for clientMembers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$__findById__clientMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/clientMembers/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__destroyById__clientMembers
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a related item by id for clientMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for clientMembers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__clientMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/clientMembers/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__updateById__clientMembers
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update a related item by id for clientMembers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for clientMembers
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$__updateById__clientMembers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/clientMembers/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__findById__owners
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find a related item by id for owners.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for owners
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$__findById__owners": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/owners/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__link__owners
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Add a related item by id for owners.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for owners
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$__link__owners": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/owners/rel/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__unlink__owners
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Remove the owners relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for owners
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__unlink__owners": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clients/:id/owners/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Client.departments() instead.
            "prototype$__get__departments": {
              isArray: true,
              url: urlBase + "/clients/:id/departments",
              method: "GET",
            },

            // INTERNAL. Use Client.departments.create() instead.
            "prototype$__create__departments": {
              url: urlBase + "/clients/:id/departments",
              method: "POST",
            },

            // INTERNAL. Use Client.departments.destroyAll() instead.
            "prototype$__delete__departments": {
              url: urlBase + "/clients/:id/departments",
              method: "DELETE",
            },

            // INTERNAL. Use Client.departments.count() instead.
            "prototype$__count__departments": {
              url: urlBase + "/clients/:id/departments/count",
              method: "GET",
            },

            // INTERNAL. Use Client.members() instead.
            "prototype$__get__members": {
              isArray: true,
              url: urlBase + "/clients/:id/members",
              method: "GET",
            },

            // INTERNAL. Use Client.members.create() instead.
            "prototype$__create__members": {
              url: urlBase + "/clients/:id/members",
              method: "POST",
            },

            // INTERNAL. Use Client.members.destroyAll() instead.
            "prototype$__delete__members": {
              url: urlBase + "/clients/:id/members",
              method: "DELETE",
            },

            // INTERNAL. Use Client.members.count() instead.
            "prototype$__count__members": {
              url: urlBase + "/clients/:id/members/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__get__clientMembers
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Queries clientMembers of client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$__get__clientMembers": {
              isArray: true,
              url: urlBase + "/clients/:id/clientMembers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__create__clientMembers
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Creates a new instance in clientMembers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$__create__clientMembers": {
              url: urlBase + "/clients/:id/clientMembers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__delete__clientMembers
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Deletes all clientMembers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__clientMembers": {
              url: urlBase + "/clients/:id/clientMembers",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__count__clientMembers
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Counts clientMembers of client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__clientMembers": {
              url: urlBase + "/clients/:id/clientMembers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$__get__owners
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Queries owners of client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$__get__owners": {
              isArray: true,
              url: urlBase + "/clients/:id/owners",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#create
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clients",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#createMany
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clients",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#upsert
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clients",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#findById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clients/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#find
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clients",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#deleteById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clients/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#prototype$updateAttributes
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clients/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Client#addOwner
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Add member as client owner
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `clientId` – `{string}` -
             *
             *  - `membersId` – `{Object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{string=}` -
             */
            "addOwner": {
              url: urlBase + "/clients/:clientId/owner/",
              method: "POST",
            },

            // INTERNAL. Use Tenant.clients.findById() instead.
            "::findById::Tenant::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/clients/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.clients.destroyById() instead.
            "::destroyById::Tenant::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/clients/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.clients.updateById() instead.
            "::updateById::Tenant::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/clients/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.clients() instead.
            "::get::Tenant::clients": {
              isArray: true,
              url: urlBase + "/tenants/:id/clients",
              method: "GET",
            },

            // INTERNAL. Use Tenant.clients.create() instead.
            "::create::Tenant::clients": {
              url: urlBase + "/tenants/:id/clients",
              method: "POST",
            },

            // INTERNAL. Use Tenant.clients.createMany() instead.
            "::createMany::Tenant::clients": {
              isArray: true,
              url: urlBase + "/tenants/:id/clients",
              method: "POST",
            },

            // INTERNAL. Use Tenant.clients.destroyAll() instead.
            "::delete::Tenant::clients": {
              url: urlBase + "/tenants/:id/clients",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.clients.count() instead.
            "::count::Tenant::clients": {
              url: urlBase + "/tenants/:id/clients/count",
              method: "GET",
            },

            // INTERNAL. Use Member.clients.findById() instead.
            "::findById::Member::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/:fk",
              method: "GET",
            },

            // INTERNAL. Use Member.clients.destroyById() instead.
            "::destroyById::Member::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.clients.updateById() instead.
            "::updateById::Member::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.clients.link() instead.
            "::link::Member::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.clients.unlink() instead.
            "::unlink::Member::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.clients.exists() instead.
            "::exists::Member::clients": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/clients/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Member.clients() instead.
            "::get::Member::clients": {
              isArray: true,
              url: urlBase + "/members/:id/clients",
              method: "GET",
            },

            // INTERNAL. Use Member.clients.create() instead.
            "::create::Member::clients": {
              url: urlBase + "/members/:id/clients",
              method: "POST",
            },

            // INTERNAL. Use Member.clients.createMany() instead.
            "::createMany::Member::clients": {
              isArray: true,
              url: urlBase + "/members/:id/clients",
              method: "POST",
            },

            // INTERNAL. Use Member.clients.destroyAll() instead.
            "::delete::Member::clients": {
              url: urlBase + "/members/:id/clients",
              method: "DELETE",
            },

            // INTERNAL. Use Member.clients.count() instead.
            "::count::Member::clients": {
              url: urlBase + "/members/:id/clients/count",
              method: "GET",
            },

            // INTERNAL. Use Department.client() instead.
            "::get::Department::client": {
              url: urlBase + "/departments/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Client.parent() instead.
            "::get::Client::parent": {
              url: urlBase + "/clients/:id/parent",
              method: "GET",
            },

            // INTERNAL. Use Integration.client() instead.
            "::get::Integration::client": {
              url: urlBase + "/integrations/:id/client",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Client#updateOrCreate
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Client#destroyById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Client#removeById
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.Client#modelName
        * @propertyOf lbServices.Client
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Client`.
        */
        R.modelName = "Client";

    /**
     * @ngdoc object
     * @name lbServices.Client.departments
     * @header lbServices.Client.departments
     * @object
     * @description
     *
     * The object `Client.departments` groups methods
     * manipulating `Department` instances related to `Client`.
     *
     * Call {@link lbServices.Client#departments Client.departments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Client#departments
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Queries departments of client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::get::Client::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.departments#count
             * @methodOf lbServices.Client.departments
             *
             * @description
             *
             * Counts departments of client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.departments.count = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::count::Client::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.departments#create
             * @methodOf lbServices.Client.departments
             *
             * @description
             *
             * Creates a new instance in departments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments.create = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::create::Client::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.departments#createMany
             * @methodOf lbServices.Client.departments
             *
             * @description
             *
             * Creates a new instance in departments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments.createMany = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::createMany::Client::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.departments#destroyAll
             * @methodOf lbServices.Client.departments
             *
             * @description
             *
             * Deletes all departments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.departments.destroyAll = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::delete::Client::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.departments#destroyById
             * @methodOf lbServices.Client.departments
             *
             * @description
             *
             * Delete a related item by id for departments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for departments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.departments.destroyById = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::destroyById::Client::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.departments#findById
             * @methodOf lbServices.Client.departments
             *
             * @description
             *
             * Find a related item by id for departments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for departments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments.findById = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::findById::Client::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.departments#updateById
             * @methodOf lbServices.Client.departments
             *
             * @description
             *
             * Update a related item by id for departments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for departments
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.departments.updateById = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::updateById::Client::departments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client#parent
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Fetches belongsTo relation parent.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.parent = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Client::parent"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Client.members
     * @header lbServices.Client.members
     * @object
     * @description
     *
     * The object `Client.members` groups methods
     * manipulating `Member` instances related to `Client`.
     *
     * Call {@link lbServices.Client#members Client.members()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Client#members
             * @methodOf lbServices.Client
             *
             * @description
             *
             * Queries members of client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::get::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#count
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Counts members of client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.members.count = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::count::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#create
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Creates a new instance in members of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.create = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::create::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#createMany
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Creates a new instance in members of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.createMany = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::createMany::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#destroyAll
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Deletes all members of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.members.destroyAll = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::delete::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#destroyById
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Delete a related item by id for members.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for members
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.members.destroyById = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::destroyById::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#exists
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Check the existence of members relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for members
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.exists = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::exists::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#findById
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Find a related item by id for members.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for members
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.findById = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::findById::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#link
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Add a related item by id for members.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for members
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.link = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::link::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#unlink
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Remove the members relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for members
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.members.unlink = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::unlink::Client::members"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Client.members#updateById
             * @methodOf lbServices.Client.members
             *
             * @description
             *
             * Update a related item by id for members.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for members
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members.updateById = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::updateById::Client::members"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Task
 * @header lbServices.Task
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Task` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Task",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tasks/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$__findById__item
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Find a related item by id for item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for item
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "prototype$__findById__item": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tasks/:id/item/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$__destroyById__item
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Delete a related item by id for item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for item
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__item": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tasks/:id/item/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$__updateById__item
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Update a related item by id for item.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for item
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "prototype$__updateById__item": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tasks/:id/item/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$__get__item
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Queries item of task.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "prototype$__get__item": {
              isArray: true,
              url: urlBase + "/tasks/:id/item",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$__create__item
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Creates a new instance in item of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Task` object.)
             * </em>
             */
            "prototype$__create__item": {
              url: urlBase + "/tasks/:id/item",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$__delete__item
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Deletes all item of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__item": {
              url: urlBase + "/tasks/:id/item",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Task#prototype$__count__item
             * @methodOf lbServices.Task
             *
             * @description
             *
             * Counts item of task.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__item": {
              url: urlBase + "/tasks/:id/item/count",
              method: "GET",
            },

            // INTERNAL. Use Member.task() instead.
            "::get::Member::task": {
              isArray: true,
              url: urlBase + "/members/:id/task",
              method: "GET",
            },

            // INTERNAL. Use Department.task.findById() instead.
            "::findById::Department::task": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/task/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.task.destroyById() instead.
            "::destroyById::Department::task": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/task/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.task.updateById() instead.
            "::updateById::Department::task": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/task/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.task() instead.
            "::get::Department::task": {
              isArray: true,
              url: urlBase + "/departments/:id/task",
              method: "GET",
            },

            // INTERNAL. Use Department.task.create() instead.
            "::create::Department::task": {
              url: urlBase + "/departments/:id/task",
              method: "POST",
            },

            // INTERNAL. Use Department.task.createMany() instead.
            "::createMany::Department::task": {
              isArray: true,
              url: urlBase + "/departments/:id/task",
              method: "POST",
            },

            // INTERNAL. Use Department.task.destroyAll() instead.
            "::delete::Department::task": {
              url: urlBase + "/departments/:id/task",
              method: "DELETE",
            },

            // INTERNAL. Use Department.task.count() instead.
            "::count::Department::task": {
              url: urlBase + "/departments/:id/task/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Task#modelName
        * @propertyOf lbServices.Task
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Task`.
        */
        R.modelName = "Task";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Tasktemplate
 * @header lbServices.Tasktemplate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Tasktemplate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Tasktemplate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tasktemplates/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Tasktemplate.form() instead.
            "prototype$__get__form": {
              url: urlBase + "/tasktemplates/:id/form",
              method: "GET",
            },

            // INTERNAL. Use Tenant.tasktemplate.findById() instead.
            "::findById::Tenant::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/tasktemplate/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.tasktemplate.destroyById() instead.
            "::destroyById::Tenant::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/tasktemplate/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.tasktemplate.updateById() instead.
            "::updateById::Tenant::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/tasktemplate/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.tasktemplate() instead.
            "::get::Tenant::tasktemplate": {
              isArray: true,
              url: urlBase + "/tenants/:id/tasktemplate",
              method: "GET",
            },

            // INTERNAL. Use Tenant.tasktemplate.create() instead.
            "::create::Tenant::tasktemplate": {
              url: urlBase + "/tenants/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Tenant.tasktemplate.createMany() instead.
            "::createMany::Tenant::tasktemplate": {
              isArray: true,
              url: urlBase + "/tenants/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Tenant.tasktemplate.destroyAll() instead.
            "::delete::Tenant::tasktemplate": {
              url: urlBase + "/tenants/:id/tasktemplate",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.tasktemplate.count() instead.
            "::count::Tenant::tasktemplate": {
              url: urlBase + "/tenants/:id/tasktemplate/count",
              method: "GET",
            },

            // INTERNAL. Use Department.tasktemplate.findById() instead.
            "::findById::Department::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tasktemplate/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.tasktemplate.destroyById() instead.
            "::destroyById::Department::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tasktemplate/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.tasktemplate.updateById() instead.
            "::updateById::Department::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tasktemplate/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.tasktemplate() instead.
            "::get::Department::tasktemplate": {
              isArray: true,
              url: urlBase + "/departments/:id/tasktemplate",
              method: "GET",
            },

            // INTERNAL. Use Department.tasktemplate.create() instead.
            "::create::Department::tasktemplate": {
              url: urlBase + "/departments/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Department.tasktemplate.createMany() instead.
            "::createMany::Department::tasktemplate": {
              isArray: true,
              url: urlBase + "/departments/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Department.tasktemplate.destroyAll() instead.
            "::delete::Department::tasktemplate": {
              url: urlBase + "/departments/:id/tasktemplate",
              method: "DELETE",
            },

            // INTERNAL. Use Department.tasktemplate.count() instead.
            "::count::Department::tasktemplate": {
              url: urlBase + "/departments/:id/tasktemplate/count",
              method: "GET",
            },

            // INTERNAL. Use Form.tasktemplate.findById() instead.
            "::findById::Form::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tasktemplate/:fk",
              method: "GET",
            },

            // INTERNAL. Use Form.tasktemplate.destroyById() instead.
            "::destroyById::Form::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tasktemplate/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tasktemplate.updateById() instead.
            "::updateById::Form::tasktemplate": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tasktemplate/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Form.tasktemplate() instead.
            "::get::Form::tasktemplate": {
              isArray: true,
              url: urlBase + "/forms/:id/tasktemplate",
              method: "GET",
            },

            // INTERNAL. Use Form.tasktemplate.create() instead.
            "::create::Form::tasktemplate": {
              url: urlBase + "/forms/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Form.tasktemplate.createMany() instead.
            "::createMany::Form::tasktemplate": {
              isArray: true,
              url: urlBase + "/forms/:id/tasktemplate",
              method: "POST",
            },

            // INTERNAL. Use Form.tasktemplate.destroyAll() instead.
            "::delete::Form::tasktemplate": {
              url: urlBase + "/forms/:id/tasktemplate",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tasktemplate.count() instead.
            "::count::Form::tasktemplate": {
              url: urlBase + "/forms/:id/tasktemplate/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Tasktemplate#modelName
        * @propertyOf lbServices.Tasktemplate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Tasktemplate`.
        */
        R.modelName = "Tasktemplate";


            /**
             * @ngdoc method
             * @name lbServices.Tasktemplate#form
             * @methodOf lbServices.Tasktemplate
             *
             * @description
             *
             * Fetches belongsTo relation form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.form = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::get::Tasktemplate::form"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Installation
 * @header lbServices.Installation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Installation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Installation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/installations/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Installation#findByApp
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Find installations by application id
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `deviceType` – `{string=}` - Device type
             *
             *  - `appId` – `{string=}` - Application id
             *
             *  - `appVersion` – `{string=}` - Application version
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "findByApp": {
              url: urlBase + "/installations/byApp",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#findByUser
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Find installations by user id
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `deviceType` – `{string=}` - Device type
             *
             *  - `userId` – `{string=}` - User id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "findByUser": {
              url: urlBase + "/installations/byUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#findBySubscriptions
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Find installations by subscriptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `deviceType` – `{string=}` - Device type
             *
             *  - `subscriptions` – `{string=}` - Subscriptions
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "findBySubscriptions": {
              url: urlBase + "/installations/bySubscriptions",
              method: "GET",
            },

            // INTERNAL. Use Installation.member() instead.
            "prototype$__get__member": {
              url: urlBase + "/installations/:id/member",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#create
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/installations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#createMany
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/installations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#upsert
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/installations",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#exists
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/installations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#findById
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/installations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#find
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/installations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#findOne
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/installations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#updateAll
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
            "updateAll": {
              url: urlBase + "/installations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#deleteById
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/installations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#count
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/installations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#prototype$updateAttributes
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Installation id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/installations/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Installation#createChangeStream
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/installations/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Member.installations.findById() instead.
            "::findById::Member::installations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/installations/:fk",
              method: "GET",
            },

            // INTERNAL. Use Member.installations.destroyById() instead.
            "::destroyById::Member::installations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/installations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.installations.updateById() instead.
            "::updateById::Member::installations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/installations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.installations() instead.
            "::get::Member::installations": {
              isArray: true,
              url: urlBase + "/members/:id/installations",
              method: "GET",
            },

            // INTERNAL. Use Member.installations.create() instead.
            "::create::Member::installations": {
              url: urlBase + "/members/:id/installations",
              method: "POST",
            },

            // INTERNAL. Use Member.installations.createMany() instead.
            "::createMany::Member::installations": {
              isArray: true,
              url: urlBase + "/members/:id/installations",
              method: "POST",
            },

            // INTERNAL. Use Member.installations.destroyAll() instead.
            "::delete::Member::installations": {
              url: urlBase + "/members/:id/installations",
              method: "DELETE",
            },

            // INTERNAL. Use Member.installations.count() instead.
            "::count::Member::installations": {
              url: urlBase + "/members/:id/installations/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Installation#updateOrCreate
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Installation#update
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Installation#destroyById
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Installation#removeById
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Installation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.Installation#modelName
        * @propertyOf lbServices.Installation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Installation`.
        */
        R.modelName = "Installation";


            /**
             * @ngdoc method
             * @name lbServices.Installation#member
             * @methodOf lbServices.Installation
             *
             * @description
             *
             * Fetches belongsTo relation member.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Installation id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.member = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::get::Installation::member"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Integration
 * @header lbServices.Integration
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Integration` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Integration",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/integrations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Integration.tenant() instead.
            "prototype$__get__tenant": {
              url: urlBase + "/integrations/:id/tenant",
              method: "GET",
            },

            // INTERNAL. Use Integration.client() instead.
            "prototype$__get__client": {
              url: urlBase + "/integrations/:id/client",
              method: "GET",
            },

            // INTERNAL. Use Integration.department() instead.
            "prototype$__get__department": {
              url: urlBase + "/integrations/:id/department",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#create
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/integrations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#createMany
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/integrations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#upsert
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/integrations",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#exists
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/integrations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#findById
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/integrations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#find
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/integrations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#findOne
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/integrations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#updateAll
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
            "updateAll": {
              url: urlBase + "/integrations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#deleteById
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/integrations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#count
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/integrations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#prototype$updateAttributes
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/integrations/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#createChangeStream
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/integrations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#request2
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Execute integration with web service.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `integration` – `{object}` -
             *
             *  - `config` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "request2": {
              url: urlBase + "/integrations/request2",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#request
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Execute integration with web service.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `integrationId` – `{string}` -
             *
             *  - `config` – `{string=}` -
             *
             *  - `fileURI` – `{string=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "request": {
              url: urlBase + "/integrations/:integrationId/request/:fileURI",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#request
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Execute integration with web service.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `integrationId` – `{string}` -
             *
             *  - `config` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "request": {
              url: urlBase + "/integrations/:integrationId/request",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#checkwebservice
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Check connection with web service.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `integrationId` – `{string}` -
             *
             *  - `config` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `response` – `{object=}` -
             */
            "checkwebservice": {
              url: urlBase + "/integrations/:integrationId/checkwebservice",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Integration#findForms
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Get Forms that use an Integration.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `integrationId` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
            "findForms": {
              url: urlBase + "/integrations/:integrationId/forms",
              method: "GET",
            },

            // INTERNAL. Use Tenant.integrations.findById() instead.
            "::findById::Tenant::integrations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/integrations/:fk",
              method: "GET",
            },

            // INTERNAL. Use Tenant.integrations.destroyById() instead.
            "::destroyById::Tenant::integrations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/integrations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.integrations.updateById() instead.
            "::updateById::Tenant::integrations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tenants/:id/integrations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.integrations() instead.
            "::get::Tenant::integrations": {
              isArray: true,
              url: urlBase + "/tenants/:id/integrations",
              method: "GET",
            },

            // INTERNAL. Use Tenant.integrations.create() instead.
            "::create::Tenant::integrations": {
              url: urlBase + "/tenants/:id/integrations",
              method: "POST",
            },

            // INTERNAL. Use Tenant.integrations.createMany() instead.
            "::createMany::Tenant::integrations": {
              isArray: true,
              url: urlBase + "/tenants/:id/integrations",
              method: "POST",
            },

            // INTERNAL. Use Tenant.integrations.destroyAll() instead.
            "::delete::Tenant::integrations": {
              url: urlBase + "/tenants/:id/integrations",
              method: "DELETE",
            },

            // INTERNAL. Use Tenant.integrations.count() instead.
            "::count::Tenant::integrations": {
              url: urlBase + "/tenants/:id/integrations/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Integration#updateOrCreate
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Integration#update
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Integration#destroyById
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Integration#removeById
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Integration` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.Integration#modelName
        * @propertyOf lbServices.Integration
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Integration`.
        */
        R.modelName = "Integration";


            /**
             * @ngdoc method
             * @name lbServices.Integration#tenant
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Fetches belongsTo relation tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R.tenant = function() {
          var TargetResource = $injector.get("Tenant");
          var action = TargetResource["::get::Integration::tenant"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Integration#client
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Fetches belongsTo relation client.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Client` object.)
             * </em>
             */
        R.client = function() {
          var TargetResource = $injector.get("Client");
          var action = TargetResource["::get::Integration::client"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Integration#department
             * @methodOf lbServices.Integration
             *
             * @description
             *
             * Fetches belongsTo relation department.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Department` object.)
             * </em>
             */
        R.department = function() {
          var TargetResource = $injector.get("Department");
          var action = TargetResource["::get::Integration::department"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Webhook
 * @header lbServices.Webhook
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Webhook` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Webhook",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/webhooks/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Webhook.tenant() instead.
            "prototype$__get__tenant": {
              url: urlBase + "/webhooks/:id/tenant",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#create
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/webhooks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#createMany
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/webhooks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#upsert
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/webhooks",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#exists
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/webhooks/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#findById
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/webhooks/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#find
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/webhooks",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#findOne
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/webhooks/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#updateAll
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
            "updateAll": {
              url: urlBase + "/webhooks/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#deleteById
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/webhooks/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#count
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/webhooks/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#prototype$updateAttributes
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/webhooks/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Webhook#createChangeStream
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/webhooks/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Tenant.webhook() instead.
            "::get::Tenant::webhook": {
              url: urlBase + "/tenants/:id/webhook",
              method: "GET",
            },

            // INTERNAL. Use Tenant.webhook.create() instead.
            "::create::Tenant::webhook": {
              url: urlBase + "/tenants/:id/webhook",
              method: "POST",
            },

            // INTERNAL. Use Tenant.webhook.createMany() instead.
            "::createMany::Tenant::webhook": {
              isArray: true,
              url: urlBase + "/tenants/:id/webhook",
              method: "POST",
            },

            // INTERNAL. Use Tenant.webhook.update() instead.
            "::update::Tenant::webhook": {
              url: urlBase + "/tenants/:id/webhook",
              method: "PUT",
            },

            // INTERNAL. Use Tenant.webhook.destroy() instead.
            "::destroy::Tenant::webhook": {
              url: urlBase + "/tenants/:id/webhook",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Webhook#updateOrCreate
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Webhook#update
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Webhook#destroyById
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Webhook#removeById
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Webhook` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.Webhook#modelName
        * @propertyOf lbServices.Webhook
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Webhook`.
        */
        R.modelName = "Webhook";


            /**
             * @ngdoc method
             * @name lbServices.Webhook#tenant
             * @methodOf lbServices.Webhook
             *
             * @description
             *
             * Fetches belongsTo relation tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R.tenant = function() {
          var TargetResource = $injector.get("Tenant");
          var action = TargetResource["::get::Webhook::tenant"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Device
 * @header lbServices.Device
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Device` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Device",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/devices/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Device#find
             * @methodOf lbServices.Device
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Device` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/devices",
              method: "GET",
            },

            // INTERNAL. Use Member.device.destroyById() instead.
            "::destroyById::Member::device": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/device/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.device() instead.
            "::get::Member::device": {
              isArray: true,
              url: urlBase + "/members/:id/device",
              method: "GET",
            },

            // INTERNAL. Use Member.device.destroyAll() instead.
            "::delete::Member::device": {
              url: urlBase + "/members/:id/device",
              method: "DELETE",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Device#modelName
        * @propertyOf lbServices.Device
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Device`.
        */
        R.modelName = "Device";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ReportConfig
 * @header lbServices.ReportConfig
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ReportConfig` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ReportConfig",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/reportConfigs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ReportConfig.form() instead.
            "prototype$__get__form": {
              url: urlBase + "/reportConfigs/:id/form",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#create
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/reportConfigs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#createMany
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/reportConfigs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#upsert
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/reportConfigs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#exists
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/reportConfigs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#findById
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/reportConfigs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#find
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/reportConfigs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#findOne
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/reportConfigs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#updateAll
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
            "updateAll": {
              url: urlBase + "/reportConfigs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#deleteById
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/reportConfigs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#count
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/reportConfigs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#prototype$updateAttributes
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/reportConfigs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#createChangeStream
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/reportConfigs/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Form.reportConfig() instead.
            "::get::Form::reportConfig": {
              url: urlBase + "/forms/:id/reportConfig",
              method: "GET",
            },

            // INTERNAL. Use Form.reportConfig.create() instead.
            "::create::Form::reportConfig": {
              url: urlBase + "/forms/:id/reportConfig",
              method: "POST",
            },

            // INTERNAL. Use Form.reportConfig.createMany() instead.
            "::createMany::Form::reportConfig": {
              isArray: true,
              url: urlBase + "/forms/:id/reportConfig",
              method: "POST",
            },

            // INTERNAL. Use Form.reportConfig.update() instead.
            "::update::Form::reportConfig": {
              url: urlBase + "/forms/:id/reportConfig",
              method: "PUT",
            },

            // INTERNAL. Use Form.reportConfig.destroy() instead.
            "::destroy::Form::reportConfig": {
              url: urlBase + "/forms/:id/reportConfig",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#updateOrCreate
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#update
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Update instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The number of instances updated
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#destroyById
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#removeById
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Delete a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ReportConfig` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];


        /**
        * @ngdoc property
        * @name lbServices.ReportConfig#modelName
        * @propertyOf lbServices.ReportConfig
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ReportConfig`.
        */
        R.modelName = "ReportConfig";


            /**
             * @ngdoc method
             * @name lbServices.ReportConfig#form
             * @methodOf lbServices.ReportConfig
             *
             * @description
             *
             * Fetches belongsTo relation form.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Form` object.)
             * </em>
             */
        R.form = function() {
          var TargetResource = $injector.get("Form");
          var action = TargetResource["::get::ReportConfig::form"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.HistoryMember
 * @header lbServices.HistoryMember
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `HistoryMember` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "HistoryMember",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/historyMembers/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.HistoryMember#modelName
        * @propertyOf lbServices.HistoryMember
        * @description
        * The name of the model represented by this $resource,
        * i.e. `HistoryMember`.
        */
        R.modelName = "HistoryMember";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TagDepartment
 * @header lbServices.TagDepartment
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TagDepartment` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TagDepartment",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tagDepartments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TagDepartment.tagMember.findById() instead.
            "prototype$__findById__tagMember": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tagDepartments/:id/tagMember/:fk",
              method: "GET",
            },

            // INTERNAL. Use TagDepartment.tagMember.destroyById() instead.
            "prototype$__destroyById__tagMember": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tagDepartments/:id/tagMember/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TagDepartment.tagMember.updateById() instead.
            "prototype$__updateById__tagMember": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tagDepartments/:id/tagMember/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TagDepartment.tagMember() instead.
            "prototype$__get__tagMember": {
              isArray: true,
              url: urlBase + "/tagDepartments/:id/tagMember",
              method: "GET",
            },

            // INTERNAL. Use TagDepartment.tagMember.create() instead.
            "prototype$__create__tagMember": {
              url: urlBase + "/tagDepartments/:id/tagMember",
              method: "POST",
            },

            // INTERNAL. Use TagDepartment.tagMember.destroyAll() instead.
            "prototype$__delete__tagMember": {
              url: urlBase + "/tagDepartments/:id/tagMember",
              method: "DELETE",
            },

            // INTERNAL. Use TagDepartment.tagMember.count() instead.
            "prototype$__count__tagMember": {
              url: urlBase + "/tagDepartments/:id/tagMember/count",
              method: "GET",
            },

            // INTERNAL. Use Member.tags.findById() instead.
            "::findById::Member::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/:fk",
              method: "GET",
            },

            // INTERNAL. Use Member.tags.destroyById() instead.
            "::destroyById::Member::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.tags.updateById() instead.
            "::updateById::Member::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.tags.link() instead.
            "::link::Member::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Member.tags.unlink() instead.
            "::unlink::Member::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Member.tags.exists() instead.
            "::exists::Member::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/members/:id/tags/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Member.tags() instead.
            "::get::Member::tags": {
              isArray: true,
              url: urlBase + "/members/:id/tags",
              method: "GET",
            },

            // INTERNAL. Use Member.tags.create() instead.
            "::create::Member::tags": {
              url: urlBase + "/members/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Member.tags.createMany() instead.
            "::createMany::Member::tags": {
              isArray: true,
              url: urlBase + "/members/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Member.tags.destroyAll() instead.
            "::delete::Member::tags": {
              url: urlBase + "/members/:id/tags",
              method: "DELETE",
            },

            // INTERNAL. Use Member.tags.count() instead.
            "::count::Member::tags": {
              url: urlBase + "/members/:id/tags/count",
              method: "GET",
            },

            // INTERNAL. Use Department.tags.findById() instead.
            "::findById::Department::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tags/:fk",
              method: "GET",
            },

            // INTERNAL. Use Department.tags.destroyById() instead.
            "::destroyById::Department::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tags/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Department.tags.updateById() instead.
            "::updateById::Department::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/departments/:id/tags/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Department.tags() instead.
            "::get::Department::tags": {
              isArray: true,
              url: urlBase + "/departments/:id/tags",
              method: "GET",
            },

            // INTERNAL. Use Department.tags.create() instead.
            "::create::Department::tags": {
              url: urlBase + "/departments/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Department.tags.createMany() instead.
            "::createMany::Department::tags": {
              isArray: true,
              url: urlBase + "/departments/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Department.tags.destroyAll() instead.
            "::delete::Department::tags": {
              url: urlBase + "/departments/:id/tags",
              method: "DELETE",
            },

            // INTERNAL. Use Department.tags.count() instead.
            "::count::Department::tags": {
              url: urlBase + "/departments/:id/tags/count",
              method: "GET",
            },

            // INTERNAL. Use Form.tags.findById() instead.
            "::findById::Form::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/:fk",
              method: "GET",
            },

            // INTERNAL. Use Form.tags.destroyById() instead.
            "::destroyById::Form::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tags.updateById() instead.
            "::updateById::Form::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Form.tags.link() instead.
            "::link::Form::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Form.tags.unlink() instead.
            "::unlink::Form::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tags.exists() instead.
            "::exists::Form::tags": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/forms/:id/tags/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Form.tags() instead.
            "::get::Form::tags": {
              isArray: true,
              url: urlBase + "/forms/:id/tags",
              method: "GET",
            },

            // INTERNAL. Use Form.tags.create() instead.
            "::create::Form::tags": {
              url: urlBase + "/forms/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Form.tags.createMany() instead.
            "::createMany::Form::tags": {
              isArray: true,
              url: urlBase + "/forms/:id/tags",
              method: "POST",
            },

            // INTERNAL. Use Form.tags.destroyAll() instead.
            "::delete::Form::tags": {
              url: urlBase + "/forms/:id/tags",
              method: "DELETE",
            },

            // INTERNAL. Use Form.tags.count() instead.
            "::count::Form::tags": {
              url: urlBase + "/forms/:id/tags/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.TagDepartment#modelName
        * @propertyOf lbServices.TagDepartment
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TagDepartment`.
        */
        R.modelName = "TagDepartment";

    /**
     * @ngdoc object
     * @name lbServices.TagDepartment.tagMember
     * @header lbServices.TagDepartment.tagMember
     * @object
     * @description
     *
     * The object `TagDepartment.tagMember` groups methods
     * manipulating `TagMember` instances related to `TagDepartment`.
     *
     * Call {@link lbServices.TagDepartment#tagMember TagDepartment.tagMember()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.TagDepartment#tagMember
             * @methodOf lbServices.TagDepartment
             *
             * @description
             *
             * Queries tagMember of tagDepartment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagMember` object.)
             * </em>
             */
        R.tagMember = function() {
          var TargetResource = $injector.get("TagMember");
          var action = TargetResource["::get::TagDepartment::tagMember"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TagDepartment.tagMember#count
             * @methodOf lbServices.TagDepartment.tagMember
             *
             * @description
             *
             * Counts tagMember of tagDepartment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tagMember.count = function() {
          var TargetResource = $injector.get("TagMember");
          var action = TargetResource["::count::TagDepartment::tagMember"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TagDepartment.tagMember#create
             * @methodOf lbServices.TagDepartment.tagMember
             *
             * @description
             *
             * Creates a new instance in tagMember of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagMember` object.)
             * </em>
             */
        R.tagMember.create = function() {
          var TargetResource = $injector.get("TagMember");
          var action = TargetResource["::create::TagDepartment::tagMember"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TagDepartment.tagMember#createMany
             * @methodOf lbServices.TagDepartment.tagMember
             *
             * @description
             *
             * Creates a new instance in tagMember of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagMember` object.)
             * </em>
             */
        R.tagMember.createMany = function() {
          var TargetResource = $injector.get("TagMember");
          var action = TargetResource["::createMany::TagDepartment::tagMember"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TagDepartment.tagMember#destroyAll
             * @methodOf lbServices.TagDepartment.tagMember
             *
             * @description
             *
             * Deletes all tagMember of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tagMember.destroyAll = function() {
          var TargetResource = $injector.get("TagMember");
          var action = TargetResource["::delete::TagDepartment::tagMember"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TagDepartment.tagMember#destroyById
             * @methodOf lbServices.TagDepartment.tagMember
             *
             * @description
             *
             * Delete a related item by id for tagMember.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tagMember
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tagMember.destroyById = function() {
          var TargetResource = $injector.get("TagMember");
          var action = TargetResource["::destroyById::TagDepartment::tagMember"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TagDepartment.tagMember#findById
             * @methodOf lbServices.TagDepartment.tagMember
             *
             * @description
             *
             * Find a related item by id for tagMember.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{string}` - Foreign key for tagMember
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagMember` object.)
             * </em>
             */
        R.tagMember.findById = function() {
          var TargetResource = $injector.get("TagMember");
          var action = TargetResource["::findById::TagDepartment::tagMember"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TagDepartment.tagMember#updateById
             * @methodOf lbServices.TagDepartment.tagMember
             *
             * @description
             *
             * Update a related item by id for tagMember.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for tagMember
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TagMember` object.)
             * </em>
             */
        R.tagMember.updateById = function() {
          var TargetResource = $injector.get("TagMember");
          var action = TargetResource["::updateById::TagDepartment::tagMember"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TagMember
 * @header lbServices.TagMember
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TagMember` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TagMember",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tagMembers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TagDepartment.tagMember.findById() instead.
            "::findById::TagDepartment::tagMember": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tagDepartments/:id/tagMember/:fk",
              method: "GET",
            },

            // INTERNAL. Use TagDepartment.tagMember.destroyById() instead.
            "::destroyById::TagDepartment::tagMember": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tagDepartments/:id/tagMember/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TagDepartment.tagMember.updateById() instead.
            "::updateById::TagDepartment::tagMember": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tagDepartments/:id/tagMember/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TagDepartment.tagMember() instead.
            "::get::TagDepartment::tagMember": {
              isArray: true,
              url: urlBase + "/tagDepartments/:id/tagMember",
              method: "GET",
            },

            // INTERNAL. Use TagDepartment.tagMember.create() instead.
            "::create::TagDepartment::tagMember": {
              url: urlBase + "/tagDepartments/:id/tagMember",
              method: "POST",
            },

            // INTERNAL. Use TagDepartment.tagMember.createMany() instead.
            "::createMany::TagDepartment::tagMember": {
              isArray: true,
              url: urlBase + "/tagDepartments/:id/tagMember",
              method: "POST",
            },

            // INTERNAL. Use TagDepartment.tagMember.destroyAll() instead.
            "::delete::TagDepartment::tagMember": {
              url: urlBase + "/tagDepartments/:id/tagMember",
              method: "DELETE",
            },

            // INTERNAL. Use TagDepartment.tagMember.count() instead.
            "::count::TagDepartment::tagMember": {
              url: urlBase + "/tagDepartments/:id/tagMember/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.TagMember#modelName
        * @propertyOf lbServices.TagMember
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TagMember`.
        */
        R.modelName = "TagMember";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AccessLogs
 * @header lbServices.AccessLogs
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AccessLogs` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AccessLogs",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/accessLogs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Tenant.accessLogs() instead.
            "::get::Tenant::accessLogs": {
              isArray: true,
              url: urlBase + "/tenants/:id/accessLogs",
              method: "GET",
            },

            // INTERNAL. Use Member.accessLogs() instead.
            "::get::Member::accessLogs": {
              isArray: true,
              url: urlBase + "/members/:id/accessLogs",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.AccessLogs#modelName
        * @propertyOf lbServices.AccessLogs
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AccessLogs`.
        */
        R.modelName = "AccessLogs";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Company
 * @header lbServices.Company
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Company` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Company",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/companies/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Company.tenant() instead.
            "prototype$__get__tenant": {
              url: urlBase + "/companies/:id/tenant",
              method: "GET",
            },

            // INTERNAL. Use Company.members() instead.
            "prototype$__get__members": {
              isArray: true,
              url: urlBase + "/companies/:id/members",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#create
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/companies",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#createMany
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/companies",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#upsert
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/companies",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#findById
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Find a model instance by id from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/companies/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#find
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/companies",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#prototype$updateAttributes
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Update attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/companies/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#delete
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Update the deleted status of a company
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `companyId` – `{string}` - Company ID
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "delete": {
              url: urlBase + "/companies/:companyId/delete",
              method: "DELETE",
            },

            // INTERNAL. Use Member.company() instead.
            "::get::Member::company": {
              url: urlBase + "/members/:id/company",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Company#updateOrCreate
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];


        /**
        * @ngdoc property
        * @name lbServices.Company#modelName
        * @propertyOf lbServices.Company
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Company`.
        */
        R.modelName = "Company";


            /**
             * @ngdoc method
             * @name lbServices.Company#tenant
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Fetches belongsTo relation tenant.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Tenant` object.)
             * </em>
             */
        R.tenant = function() {
          var TargetResource = $injector.get("Tenant");
          var action = TargetResource["::get::Company::tenant"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company#members
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries members of company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Member` object.)
             * </em>
             */
        R.members = function() {
          var TargetResource = $injector.get("Member");
          var action = TargetResource["::get::Company::members"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && host !== urlBaseHost) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);
